export default {
	demo_account:{
        footerpoint1:`Fxview is the trading name of the Fxview group of companies which consists of:`,
        footerpoint2:`- Parent company, Finvasia Securities Private Ltd, regulated by the Securities and Exchange Board of India (Licence No INZ000176037)`,
        footerpoint3:`- Charlgate Ltd, regulated by the Cyprus Securities and Exchange Commission (Licence No 367/18)`,
        footerpoint4:`- Charlgate SVG LLC (Reg. No. 1112 LLC 2021) with registered address at First Floor, First St Vincent Bank Ltd Building, James Street, Kingstown, Saint Vincent and the Grenadines.`,
        footerpoint5:`- Nevea Services Ltd (Reg. No. 422664) with registered address at 319, 28th October Street, Kanika Business Center, Office 201B, Limassol 3105, Cyprus.`,
        footerpoint6:`The merchant company is Nevea Services Ltd with registered address at 319, 28th October Street, Kanika Business Center, Office 201B, Limassol 3105, Cyprus. The merchant company provides content, administrative services, payment processing and safekeeping services.`,
        footerpoint7:`Clients must be at least 18 years old to use the services of Fxview.`,
        footerpoint8:`Trading complex instruments on margin carries a high level of risk and may not be suitable for all investors. Before deciding to trade, you should carefully consider your trading objectives, level of experience and risk appetite. It is possible for you to sustain losses that exceed your invested capital, and therefore you should not deposit money that you cannot afford to lose. Please ensure you fully understand the risks and take appropriate care to manage them.`,
        footerpoint9:`This site contains links to websites controlled or offered by third parties. Fxview has not reviewed and hereby disclaims responsibility for any information or materials posted at any of the sites linked to this site. By creating a link to a thirdparty website, Fxview does not endorse or recommend any products or services offered on that website. The information contained on this site is intended for informational purposes only. Therefore, it should not be regarded as an offer or solicitation to any person in any jurisdiction in which such an offer or solicitation is not authorized or to any person to whom it would be unlawful to make such an offer or solicitation, nor regarded as recommendation to buy, sell or otherwise deal with any particular trade. If you are not sure about your local trading regulations, then you should leave this site immediately.`,
        footerpoint10:`You are strongly advised to obtain independent financial, legal and tax advice before proceeding with any trade. Nothing on this site should be read or construed as constituting advice on the part of Fxview or any of its affiliates, directors, officers or employees.`,
        footerpoint11:`The services of Fxview and the information on this site are not directed at residents of the Crimea, Cuba, Cyprus, India, Iran, North Korea, Sudan, Syria, and the United States and are not intended for distribution to, or use by, any person in any country or jurisdiction where such distribution or use would be contrary to local law or regulation.`,
        high_risk_warning:'High Risk Warning',
        open_a:'Open a',
        free_demo:'Free Demo',
        account_on:'Account',
        mt4:'MetaTrader 4',
        mt5:'MetaTrader 5',
        act:'ActTrader',
        or:'or',
        register:'Register',
        login:'Login',
        have_acc:'Have an account?',
        register_form:{
            otp_msg:'One-Time Pin has been sent to your email. Please enter it below.',
            open_an_account:'Open an Account',
            will_take_minut:'It will take less than a minute',
            select_residence_country:'Select Residence Country',
            email:'Email Address',
            pass:'Enter Password',
            cpass:'Confirm Password',
            privacy_agree:'By Signing up you agree to our',
            privacy_policy:'Privacy Policy',
        },
        website_use:'Website Use',
        cookies_policy:'Cookies Policy',
	    refund_policy:'Refund Policy',
	    AML_policy:'AML Policy',
        sub_heading1:{
            our:'Our',
            features:'Features',
            title:`Unleash your trading potential and conquer the market with our unbeatable trading conditions.`,
            sub_container1:{
                in_depth:'In-depth',
                learning:'Learning',
                description:'Enhance your trading by signing up to our free webinars and learn from experts. Our webinars are specifically designed to boost your market knowledge and hone your trading skills.',
            },
            sub_container2:{
                risk_free:`Risk-free`,
                trading:'Trading',
                description:`Whether you're new to trading or already an experienced forex trader, discover your trading prowess at Fxview, with our risk-free forex demo account.`,
            },
            sub_container3:{
                hundreds_of:'Hundreds of',
                tradable_instruments:'tradable instruments',
                description:'Gain access to over 500 trading products ranging from Fx to Commodities, Stocks, Indices, and digital assets.',
            },
            sub_container4:{
                real_prices_with:'Real prices with',
                fast_execution:'fast execution',
                description:'Experience real-time trading, explore a plethora of tools and strategies, and sharpen your skills all while trading in a completely risk-free demo account.',
            },
        },
        sub_heading2:{
            frequently_asked:'Frequently Asked',
            questions:'Questions',
            description:`Get Your Questions Answered: Your Ultimate Guide.`,
            more_info:'More Info',
            faq1:{
                question:`Is there a time limit to using a demo account?`,
                answer:`You can use the demo account for as long as you wish. The account only gets deactivated if there is no activity for 30 consecutive days.`,
            },
            faq2:{
                question:`Can I open multiple demo accounts with different trading platforms?`,
                answer:`Yes, you can. There is no limit on the number of demo accounts one can open with different platforms.`,
            },
            faq3:{
                question:`What’s the difference between a demo and live trading account?`,
                answer:`Live trading accounts need to be funded with real money for placing trades. Whereas demo accounts are funded with virtual money to eliminate the risk of losing real money. Other than this the trading conditions, tools, and features are almost the same for both demo and live accounts.`,
            },
            faq4:{
                question:`What’s the maximum amount I can trade in a demo account?`,
                answer:`You will get $100,000 to trade in the demo account. This amount gets refilled once the balance goes nil.`,
            },
            faq5:{
                question:`Can I practice CFD trading in a demo account?`,
                answer:`Yes, you are free to trade any instrument that we offer for live trading on your demo account.`,
            },
            faq6:{
                question:`Can I open multiple demo accounts?`,
                answer:`Yes, you can open multiple demo accounts with different platforms. But only one demo account can be opened for each type of account.`,
            },
            faq7:{
                question:`Is there an inactivity fee on demo account?`,
                answer:`No, we don’t charge any inactivity fee, but the demo account will be deactivated if not used for 30 consecutive days.`,
            },
        }
    },
    financial_details: 'Financial Details',
	reg_step_one_point: 'If employed please specify',
	reg_step_one_point_two: 'Estimated Annual Income (USD)',
	reg_step_one_point_three: 'Estimated Net Worth (USD)',
	reg_step_one_point_four: 'Source Of Funds',
	accountancy: 'Accountancy',
	admin_secretarial: 'Admin/Secretarial',
	auctions: 'Auctions',
	catering_hospitality: 'Catering/Hospitality',
	creative_media: 'Creative/Media ',
	education: 'Education',
	emergency_services: 'Emergency Services',
	engineering: 'Engineering',
	financial_services: 'Financial Services',
	gas_petrol: 'Gas/Petrol',
	health_medicine: 'Health/Medicine',
	army_industry: 'Army/Army Industry',
	hr: 'HR',
	insurance: 'Insurance ',
	legal: 'Legal',
	leisure_tourism: 'Leisure/Tourism ',
	manufacturing: 'Manufacturing ',
	marketing_pr_advertising: 'Marketing/PR/Advertising',
	pharmaceuticals: 'Pharmaceuticals ',
	precious_metals_Diamonds: 'Precious metals/Diamonds',
	property_construction_real_state: 'Property Construction/Real Estate ',
	retail: 'Retail',
	sales: 'Sales',
	social_care_services: 'Social Care/Services ',
	telecommunications: 'Telecommunications',
	transport_logistics: 'Transport/Logistics ',
	trust_charities_foundations: 'Trust/Charities/Foundations ',
	virtual_currency: 'Virtual Currency',
	other_please_specify: 'Other (Please specify)',
	till_ten_thousand: '0-10,000',
	till_fifty_thousand: '10,000-50,000',
	till_one_lac:'50,000-100,000',
	till_two_lac: '100,000-200,000' ,
	above_two_lac:'Above 200,000',
	till_fiftythousand: '0-50,000',
	// till_fiftythousand: '50,000-100,000',
	till_three_lac: '100,000-300,000',
	above_three_lac: '300,000+',
	employment: 'Employment',
	inheritance: 'Inheritance',
	investment: 'Investment',
	real_estate: 'Real Estate' ,
	savings: 'Savings',
	other: 'Other',
	reg_step_three: `Let's test your trading experience`,
	reg_step_three_point: 'As a regulated entity, we are required to assess whether you have appropriate understanding to trade leveraged products. Please complete your Appropriateness test carefully, as your responses will be used to determine whether you can open a Live trading account with us.',
	start_test: 'Start Test',
	
	"Keys": "Arabic",
	"depMsz1": "وقت المعالجة:",
	"depMsz2": "من يوم إلى 5 أيام عمل",
	"depMsz3": "رسوم:",
	"depMsz4": "0",
	"depMsz10": "فورية 24/7",
	"MiniDepositAmount": "الحد الأدنى لمبلغ الإيداع",
	"DntSkill": "ليس لديك أي معرف سكريل ، من فضلك",
	"depMsz12": "لتغيير معرف Skrill الخاص بك",
	"netId": "معرفNetteller :",
	"depMsz13": "ليس حساب Netteller الصحيح؟ الرجاء",
	"depMsz14": "لتغيير معرف Netteller  ",
	"Clickhere": "انقر هنا.",
	"DntNetteler": "ليس لديك أي معرف Netteller ، من فضلك",
	"Tocreate": "لإنشاء.",
	"conPay": "تأكيد الإيداع",
	"depMsz15": "يرجى التأكد من صحة تفاصيل الإيداع. إذا كنت سعيدا بكل شيء، انقر على زر â € \"Fund Nowâ € للمتابعة ™. يرجى ملاحظة أنه إذا قمت بإجراء سحب بعد الإيداع في حسابك، فمن المرجح أن يتم إرجاع أموالك من خلال نفس الطريقة المستخدمة للإيداع.",
	"accountId": "معرف الحساب",
	"feeUsd": "الرسوم (دولار أمريكي)",
	"depositAmount": "مبلغ الإيداع",
	"paymentMethod": "طريقة الإيداع",
	"backToStep": "الخطوة السابقة",
	"procToPay": "المتابعة للدفع",
	"personalInfo": "معلومات شخصية",
	"fname": "الاسم الأول",
	"lname": "اسم العائلة",
	"InvalidNumber": "رقم غير صالح",
	"saveContinue": "حفظ ومتابعة",
	"termsAgreeRqd": "يرجى الموافقة على الشروط للإستمرار",
	"googleOtp": "يرجى إدخال رمز المرور مرة واحدة المعروض في تطبيق <strong>Google Authenticator</strong>.",
	"enterAmount": "إدخال المبلغ",
	"allowDeposit1lac": "نحن لا نسمح إيداع أكثر من 1،00،000 للحساب التجريبي",
	"SearchSomething": "البحث هنا",
	"search": "بحث",
	"Prev": "السابق",
	"Next": "التالي",
	"PleaseEnsureCorrect": "الرجاء التأكد من صحة التفاصيل",
	"lg_riskWarningMsg": "العقود مقابل الفروقات هي أدوات معقدة وتأتي مع مخاطر عالية من فقدان المال بسرعة بسبب الرافعة المالية. الغالبية العظمى من حسابات عملاء التجزئة تخسر المال عند التداول في عقود الفروقات. يجب عليك أن تنظر فيما إذا كنت تفهم كيفية عمل العقود مقابل الفروقات وما إذا كنت تستطيع تحمل المخاطر العالية لفقدان أموالك.",
	"lg_welcomeMsgHeadone": "شروط التداول التنافسية",
	"lg_welcomeMsg1": "استفد من فروق أسعار منخفضة إلى 0.0 نقطة على أزواج العملات الأجنبية الرئيسية، وعمولات بقيمة 1 دولار لكل 100,000 دولار لكل جانب.",
	"lg_welcomeMsgHeadtwo": "منصاتنا",
	"lg_welcomeMsg2": "الوصول إلى الأسواق الأكثر شعبية في العالم على منصاتنا السريعة والموثوقة - MT4 و MT5 و ActTrader",
	"lg_welcomeMsgHeadthree": "أدوات التداول",
	"lg_welcomeMsg3": "الوصول إلى مجموعة واسعة من أدوات التداول مثل Autochartist، Traderâ € ™ ™ق أداة مربع، API التداول وأكثر من ذلك",
	"lg_signin": "تسجيل الدخول إلى Fxview",
	"lg_emailaddress": "عنوان البريد الإلكتروني",
	"lg_EmailfieldValid": "الرجاء إدخال عنوان بريد إلكتروني صالح",
	"lg_EmailfieldReq": "حقل البريد الإلكتروني مطلوب",
	"lg_password": "شعار",
	"lg_logIn": "تسجيل الدخول",
	"lg_forgotPassword": "نسيت كلمة المرور",
	"lg_donthaveaccount": "Donâ€™t have an account? ***",
	"lg_signuphere": "سجل هنا",
	"lg_charlgateMsGlobal": "شركة Finvasia Capital South Africa (PTY) Ltd مسجلة في جنوب إفريقيا برقم 2018/303451/07. عنوان المكتب المسجل هو 44 3rd Floor, 34 Whiteley Blvd, Melrose Arch, Birnam, 2196.",
	"lg_charlgateMsEurope": "شارلجيت المحدودة مرخصة ومنظمة من قبل CySEC ، مع رقم الترخيص 367/18 ورقم تسجيل الشركة 372060.",
	"lg_varify2step": "التحقق بخطوتين",
	"lg_EnterAuthCode": "إدخال كود المصادقة",
	"lg_submit": "إرسال",
	"lg_backLogin": "العودة إلى تسجيل الدخول",
	"lg_footerMsz2": "رأس مالك في خطر. قد تفقد كل رأس المال المستثمر.",
	"lg_riskDisclaimer": "إخلاء مسؤولية المخاطر",
	"fp_forgotPasswordText": "يرجى إدخال عنوان بريدك الإلكتروني المسجل مع fxview حتى نتمكن من مساعدتك في إنشاء كلمة مرور جديدة.",
	"fp_resetPassword": "إعادة تعيين كلمة المرور",
	"fp_RESEND_EMAIL": "إعادة إرسال البريد الإلكتروني",
	"fp_backLogin": "العودة إلى صفحة تسجيل الدخول",
	"fp_charlgateMsg": "شارلجيت المحدودة تمتلك fxview.com.  Charlgate Ltd هي شركة مرخصة ومنظمة من قبل لجنة الأوراق المالية والبورصات القبرصية CySEC (CySEC License number 367/18 ورقم تسجيل الشركة : 372060 ) وعضو في صندوق تعويضات المستثمرين (ICF).",
	"reg_welcomemsg1": "<h3>فروق الأس</h3><p>عار من 0.0 نقطة</p>",
	"reg_welcomemsg2": "<h3>دولار عمولة </h3><p>لكل 100 الف </p>",
	"reg_welcomemsg3": "<h3>مجموعة مت</h3><p>نوعة من أدوات التداول</p>",
	"reg_welcomemsg4": "<h3>تنفيذ </h3><p>سريع جدا</p>",
	"reg_welcomemsg5": "<h3>100٪</h3><p> مكافأة الإيداع</p>",
	"reg_openacc": "فتح حساب",
	"reg_takeminute": "سيستغرق أقل من دقيقة",
	"reg_selectacctype": "تحديد نوع الحساب",
	"reg_selectcountry": "اختيار بلد الإقامة",
	"reg_Enterfname": 'أدخل الاسم الأول',
	"reg_Entername": 'أدخل أسمك',
	"reg_Enterlname": 'إدخال اسم آخر',
	"reg_Enteremail": "أدخل عنوان البريد الإلكتروني",
	"reg_Enterpwd": "أدخل كلمة المرور",
	"reg_passwordFieldReq": "حقل كلمة المرور مطلوب",
	"reg_passCharVal": "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل، وأن تتضمن رقما ورقما كبيرا واحد على الأقل وحرفا خاصا واحد (!@#$٪^)",
	"reg_conPassword": "تأكيد كلمة المرور",
	"reg_ConfpasswordReq": "حقل تأكيد كلمة المرور مطلوب.",
	"reg_newConfFieldSame": "كلمات المرور المدخلة غير متطابقة. الرجاء المحاولة مرة أخرى",
	"reg_captchaErr": "كابتشا غير صالح",
	"reg_register": "سجل",
	"reg_signagree": "من خلال التوقيع كنت توافق على",
	"reg_privacyPolicy": " سياسة الخصوصية",
	"reg_haveAccount": "هل لديك حساب؟",
	"reg_login": "تسجيل الدخول",
	"reg_registerMsz2": "تم إرسال رمز لمرة واحدة إلى بريدك الإلكتروني. يرجى إدخاله أدناه.",
	"reg_enterOtp": "أدخل OTP",
	"reg_submit": "إرسال",
	"reg_resendotp": "إعادة إرسال OTP",
	"rp_passwordHashMsz2": "تم تغيير كلمة المرور بنجاح. نقر",
	"rp_here": "هنا",
	"rp_toLogin": "لتسجيل الدخول",
	"rp_otherWayHelp": "طرق أخرى للحصول على المساعدة",
	"rp_chatWithUs": "دردش معنا",
	"rp_or": "أو",
	"rp_callUs": "اتصل بنا",
	"prof_verified": "التحقق",
	"prof_undrreview": "طلبك قيد المراجعة!",
	"prof_checkstatus": "يرجى التحقق من حالة تذكرتك",
	"prof_clickhere": "اضغط هنا",
	"prof_completeRegister": "التسجيل الكامل",
	"prof_basicDetail": "معلومات أساسية",
	"prof_addressDetail": "معلومات العنوان",
	"prof_paymentDetail": "تفاصيل الدفع",
	"prof_documents": "الوثائق",
	"prof_fname": "الاسم الأول",
	"prof_lname": "اسم العائلة",
	"prof_DOB": "تاريخ الميلاد",
	"prof_phone": "الهاتف",
	"prof_Member": "عضو",
	"prof_companyname": "اسم الشركة",
	"prof_incorporationdate": "تاريخ التأسيس",
	"prof_currency": "عملة",
	"prof_emailaddress": "عنوان البريد الإلكتروني",
	"prof_PEP": "الشخص المكشوف سياسيا (PEP)",
	"prof_addressLine1": "سطر العنوان السكني 1",
	"prof_addressLine2": "سطر العنوان السكني 2",
	"prof_postCode": "رمز البريد",
	"prof_city": "المدينة أو المنطقة",
	"prof_resCountry": "بلد الإقامة",
	"prof_bankName": "اسم البنك:",
	"prof_AccNumber": "رقم الحساب:",
	"prof_Pending": "معلقه",
	"prof_Disable": "تعطيل",
	"prof_viewDetail": "عرض التفاصيل",
	"prof_paymentMethod": "طريقة الإيداع",
	"prof_AccountName": "اسم الحساب",
	"prof_SwiftCode": "رمز سويفت/BIC/الفرز",
	"prof_IBAN": "ايبان",
	"prof_bankAdd": "عنوان البنك:",
	"prof_onlinePayId": "معرف الدفع عبر الإنترنت:",
	"prof_Change": "تغيير",
	"prof_CreditCard": "رقم بطاقة الائتمان:",
	"prof_ExpiryDate": "تاريخ انتهاء الصلاحية:",
	"prof_noBankDetail": "لا توجد تفاصيل البنك",
	"prof_AddBank": "إضافة بنك",
	"prof_AddCard": "إضافة بطاقة الائتمان",
	"prof_noDocuments": "لا توجد مستندات",
	"prof_disablecard": "يرجى تعطيل طريقة الدفع ببطاقة الائتمان الخاصة بي، والمعلومات على النحو الوارد أدناه:",
	"prof_creditcardno": "رقم بطاقة الائتمان : **** **** ****",
	"prof_bankpaymentmethod": "يرجى تعطيل طريقة دفع التحويل المصرفي، والمعلومات على النحو الوارد أدناه:",
	"prof_diablepaymentmethod": "تعطيل طريقة الدفع",
	"prof_addpeymentmethod": "إضافة طريقة الدفع",
	"twoFA_faText": "المصادقة الثنائية 2FA",
	"twoFA_alreadyEnabled": "تمكين",
	"twoFA_setUp2FA": "إعداد المصادقة الثنائية 2FA",
	"twoFA_clickToDisable": "انقر لتعطيل",
	"twoFA_clickToEnable": "انقر لتمكين",
	"twoFA_enable2FaText": "تمكين المصادقة الثنائية 2FA",
	"twoFA_accounntSafe3Steps": "اجعل حسابك أكثر أمانا في ثلاث خطوات سهلة:",
	"twoFA_downloaduthApp": "تنزيل تطبيق مصادق",
	"twoFA_downloaduthAppText": "قم بتنزيل مصادق Authy أو Google  وثبته على هاتفك أو جهازك اللوحي.",
	"twoFA_scanQrCode": "مسح رمز الاستجابة السريعة",
	"twoFA_scanQrCodeText": "افتح تطبيق المصادقة وامسح الصورة ضوئيا إلى اليسار باستخدام كاميرا هاتفك.",
	"twoFA_loginYourCode": "تسجيل الدخول باستخدام الرمز",
	"twoFA_enter6DigitCode": "أدخل رمز التحقق المكون من 6 أرقام الذي تم إنشاؤه.",
	"twoFA_activate": "تنشيط",
	"twoFA_enterOtpDisableQrCode": "الرجاء إدخال OTP لتعطيل رمز الاستجابة السريعة",
	"twoFA_disableCodeText": "تعطيل باستخدام التعليمات البرمجية",
	"cp_changePassword": "تغيير كلمة المرور",
	"cp_oldpwd": "كلمة المرور القديمة",
	"cp_newPassword": "كلمة مرور جديدة",
	"cp_conPassword": "تأكيد كلمة المرور",
	"cp_passCharval": "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل، و15 حرفا كحد أقصى، وأن تتضمن رقما ورقما كبيرا واحد على الأقل وحرفا خاصا (!@#$٪^*)",
	"welcm_fewStepAway": "أنت على بعد خطوات قليلة",
	"welcm_activateFxviewAccountNow": "تفعيل حساب Fxview الخاص بك الآن!",
	"welcm_setupFxViewAcc": "إعداد حساب fxview الخاص بك",
	"welcm_modify": "تعديل",
	"welcm_addFund": "إضافة أموال",
	"welcm_startTrading": "بدء التداول",
	"welcm_welcomeFxView": "مرحبا بكم في Fxview!",
	"welcm_welFxviewCon": "أنت على استعداد تقريبا لبدء التداول. يرجى إكمال طلب حساب التداول الخاص بك وتحميل وثائق الهوية اللازمة.",
	"welcm_completeReg": "التسجيل الكامل",
	"welcm_tryDemoAcc": "جرب حساب تجريبي",
	"welcm_tryDemoAccCon": "جرب منصات التداول الخاصة بنا - MT4 و MT5 و ActTrader - وطور مهارات تداول عقود الفروقات الخاصة بك. ممارسة التداول مع الأموال الافتراضية",
	"welcm_createDemoAccount": "الحساب التجريبي",
	"welcm_downloadPlatform": "تحميل منصة",
	"welcm_MT4": "ميتا تريدر 4",
	"welcm_winIosAndroid": "Windows/IOS/Android",
	"welcm_MT5": "ميتا تريدر 5",
	"welcm_actTrader": "ActTrader<sup>TM</sup>",
	"welcm_rangeTradTools": "مجموعة من أدوات التداول",
	"welcm_wlcmMsz1": "تحديد الأفكار التجارية التي يتم إنشاؤها تلقائيا استنادا إلى أنماط الرسم البياني، وهروب، وانتكاسات الاتجاه، وأنماط فيبوناتشي والمؤشرات التقنية.",
	"welcm_wlcmMsz2": "استكشف مجموعة واسعة من الأفكار التجارية القابلة للتنفيذ المعترف بها على أساس أنماط الرسم البياني المتعددة والمؤشرات التقنية عبر فئة الأصول المختلفة.",
	"welcm_wlcmMsz3": "ابق على خطوة إلى الأمام مع الأخبار المالية في الوقت الحقيقي والتحديثات على الأحداث الجغرافية والسياسية لاتخاذ قرارات التداول المستنيرة.",
	"welcm_wlcmMsz4": "البقاء على اطلاع على التقويم الاقتصادي في الوقت الحقيقي الذي يشمل الأحداث الاقتصادية العالمية الرئيسية والمؤشرات في الأفق.",
	"welcm_wlcmMsz5": "احصل على تجربة تداول لا مثيل لها عبر برنامج استضافة VPS مناسب يسمح لك بالتداول دون انقطاع مع تقليل زمن الوصول.",
	"welcm_SeeMore": "شاهد المزيد",
	"notif_Notification": "اخطار",
	"notif_noNewNotification": "لا توجد إشعارات جديدة",
	"verf_reqProcessing": "معالجة الطلب...",
	"verf_reqVerify": "طلب التحقق",
	"verf_dear": "السيد او السيدة ",
	"verf_requestVerifyWith": "تمت معالجة طلب السحب بنجاح",
	"verf_backWithList": "العودة إلى قائمة السحوبات",
	"verf_reqFailed": "فشل الطلب",
	"verf_msg": "فشل طلب السحب",
	"refer_Refera": "إحالة ",
	"refer_friend": "صديق",
	"refer_opportunity": "لدينا إحالة برنامج صديق يمنحك فرصة لكسب 20 دولارا لكل صديق كنت أشير. Whatâ € ™ ™ق أكثر من ذلك ، سوف يكافأ صديقك أيضا 20 دولارا عند الاشتراك مع البريد الإلكتروني الدعوة الخاصة بك.",
	"refer_Refernow": "الرجوع الآن",
	"refer_howorks": "كيف يعمل",
	"refer_everyclient": "لكل عميل تقوم بإحالته، سوف نكافئك بمبلغ 20 دولارا. شارك الأشياء المفضلة لديك حول fxview مع أصدقائك واستمتع بهامش تداول إضافي، علينا.",
	"refer_stepmsg1": "سجل أو سجل الدخول إلى حساب fxview الخاص بك",
	"refer_stepmsg2": "دعوة صديقك باستخدام النموذج في منطقة العميل",
	"refer_stepmsg3": "سوف تتلقى صديقك دعوة عبر البريد الإلكتروني وسوف تتبع الخطوات للتسجيل",
	"refer_stepmsg4": "ستتلقى أنت وصديقك 20 دولارًا أمريكيًا بمجرد قيامك أنت وصديقك بتمويل حسابهما بمبلغ 200 دولار أو أكثر",
	"refer_referEmail": "البريد الإلكتروني المحال",
	"refer_addmore": "إضافة المزيد",
	"refer_nowrefer": "الرجوع الآن",
	"refer_successRefer": "لقد تمت الإشارة بنجاح",
	"refer_refrMore": "الرجوع إلى المزيد",
	"refer_godashboard": "الانتقال إلى لوحة المعلومات",
	"refer_partnerprog": "برنامج الشراكة الآخر",
	"refer_Affilialte": "برنامج الشركاء",
	"refer_uniquelink": "احصل على رابط الإحالة الفريد",
	"refer_trackearn": "تتبع أرباحك من الإحالات",
	"refer_monitorStatus": "مراقبة حالة الإحالات",
	"refer_withdrawearn": "سحب أرباحك كما يحلو لك",
	"refer_register": "سجل",
	"refer_knowmore": "اعرف المزيد",
	"refer_brokerprogram": "إدخال برنامج الوسيط",
	"refer_uniqueIB": "بوابة IB فريدة",
	"refer_IBmanager": "مدير IB مخصص",
	"refer_controlearn": "السيطرة على أرباحك",
	"refer_regislink": "ارتباط تسجيل IB فريد",
	"refer_clientlist": "قائمة العملاء",
	"refer_email": "البريد الإلكتروني",
	"refer_accountStatus": "مرحلة الحساب",
	"refer_volumereq": "متطلبات وحدة التخزين",
	"refer_tradedvol": "حجم التداول",
	"refer_qualified": "المؤهلين",
	"refer_action": "فعل",
	"refer_successDelete": "تم حذف بنجاح",
	"refer_fromReflist": "من قائمة المرجعية",
	"refer_wantTodelete": "هل تريد حذف",
	"refer_confrm": "أكد",
	"refer_enterEmailrefer": "الرجاء إدخال البريد الإلكتروني للرجوع",
	"refer_error": "خطأ",
	"refer_errorReferal": "يجب التحقق من هويتك وتمويلك قبل الإحالة.",
	"dash_overview": "نظره عامه",
	"dash_traderRoom": "غرفة التاجر",
	"dash_personalInfo": "معلومات شخصية",
	"dash_declaration": "إعلان",
	"dash_uploadDocumen": "تحميل المستندات الشخصية",
	"dash_completeReg": "التسجيل الكامل",
	"dash_checkticketstatus": "يرجى التحقق من حالة تذكرتك.",
	"dash_clickhere": "اضغط هنا",
	"dash_TradingAcc": "حسابات التداول",
	"dash_live": "حقيقي",
	"dash_demo": "تجريبي",
	"dash_Platform": "منصة",
	"dash_tradAccId": "معرف الحساب",
	"dash_Leverage": "الرافعة",
	"dash_currency": "عملة",
	"dash_marketSummary": "ملخص السوق",
	"dash_marketInsight": "رؤى السوق",
	"dash_news": "خبر",
	"dash_EconomicCal": "التقويم الاقتصادي",
	"dash_thereIsNoRecord": "لم يتم العثور على سجلات",
	"dash_Time": "الوقت",
	"dash_Country": "بلد",
	"dash_event": "حدث",
	"dash_frequency": "التردد: شهريا",
	"dash_autochartist": "شارة تلقائية",
	"dash_nodata": "لا توجد بيانات",
	"dash_time": "الوقت",
	"dash_impact": "تأثير",
	"dash_actual": "حقيقي",
	"dash_forecast": "تنبؤ",
	"dash_previous": "سابق",
	"dp_download": "تحميل",
	"dp_actTrader": "ActTrader<sup>TM</sup>",
	"dp_forWindows": "لويندوز",
	"dp_forIos": "بالنسبة إلى iOS",
	"dp_forAndroid": "للأندرويد",
	"dp_ActWebTrader": "Act Web Trader",
	"dp_MT4WebTrader": "MT4 ويب تريدر",
	"dp_forMAC": "ل MAC",
	"dp_MT5WebTrader": "MT5 ويب تريدر",
	"forWindows": "نوافذ",
	"forIos": "دائره الرقابه الداخليه",
	"WEB": "نسيج",
	"acc_Aclist": "قائمة الحسابات",
	"acc_changeLeverage": "تغيير الرافعة المالية",
	"acc_changeplatPass": "تغيير كلمة مرور النظام الأساسي",
	"acc_InternalTrans": "النقل الداخلي",
	"bnk_bankDetails": "تفاصيل البنك",
	"bnk_MicrCode": "رمز ميكر:",
	"bnk_IBANNumber": "رقم حساب IBAN",
	"bnk_ifscSwiftBic": "ifsc / سويفت / بيك (رمز قصير من المملكة المتحدة)",
	"bnk_Save": "حفظ",
	"db_requestBon": "طلب مكافأة",
	"db_removeBon": "إزالة المكافأة",
	"db_bonusList": "قائمة المكافآت",
	"bver_bonusVerMsz1": "تمت معالجة طلب المكافأة بنجاح.",
	"bver_backBonusList": "العودة إلى قائمة المكافآت",
	"bver_reqFailed": "فشل الطلب",
	"bl_bonusList": "قائمة المكافآت",
	"bl_created": "تاريخ",
	"bl_amount": "مبلغ",
	"bl_bonusType": "نوع المكافأة",
	"bl_status": "حالة",
	"bl_comments": "التعليقات",
	"bl_complete": "كامل",
	"bl_pending": "المعلقه",
	"rb_removeBonus": "إزالة المكافأة",
	"rb_removebonusMsz1": "عذرا أنت غير مؤهل لإزالة المكافأة.",
	"rb_availbonus": "المكافأة المتاحة:",
	"rb_bonusremove": "أدخل مبلغ المكافأة لإزالته",
	"rb_submit": "إرسال",
	"rb_googleAuth1": "الرجاء إدخال رقم 6 رقم واحد دبوس هو مبين في",
	"rb_googleAuth2": "مصادق جوجل",
	"rb_googleAuth3": "التطبيق",
	"rb_validate": "التحقق",
	"rb_googleAuth4": "هل تواجه مشكلة في رمز المصادقة الثنائي؟",
	"rb_googleAuth5": "انقر هنا للتحقق من البريد الإلكتروني",
	"rb_googleAuth6": "لقد أرسلنا رابطا إلى بريدك الإلكتروني",
	"rb_bonusGoogleAuth": "يرجى النقر على الرابط من أجل المضي قدما في السحب الخاص بك",
	"rb_googleAuth7": "ألم تتلق رسالة بريد إلكتروني في صندوق البريد الوارد أو مجلد الرسائل غير المرغوب فيها؟ ارسال",
	"rb_googleAuth8": "لم يتم تمكين المصادقة الثنائية على حسابك.",
	"rb_googleAuth9": "تضيف المصادقة الثنائية طبقة إضافية من الأمان ، مما يضمن أنك أنت من يحاول إجراء تغييرات في حساب fxview الخاص بك.",
	"rb_googleAuth10": "انقر هنا لتمكين مصادقة Google",
	"rb_congo": "مبروك",
	"rb_removeBonusCongoMsz": "تمت إزالة المكافأة بنجاح ل حسابك",
	"rb_goToDash": "الانتقال إلى لوحة المعلومات",
	"rb_noTradingAccFound": "لا يوجد حساب تداول حقيقي!",
	"rb_plzWaitWhileProc": "يرجى الانتظار بينما نحن معالجة البيانات الخاصة بك...",
	"rb_bonusGooglerequest": "يرجى النقر على الرابط من أجل المضي قدما في طلب المكافأة الخاص بك",
	"rb_bonusGoogleremove": "يرجى النقر على الرابط من أجل المضي قدما",
	"req_bonus": "مكافاه",
	"req_bonusMsz1": "نأسف انت غير مؤهل. مول حسابك للاستفادة من المكافأة.",
	"req_allowMaxBonus": "الحد الأقصى للمكافأة المسموح بها",
	"req_amount": "مبلغ",
	"req_agreeTerms": "أوافق على الشروط والأحكام",
	"reg_Agreee": "أوافق على",
	"reg_TERMS": "الشروط والأحكام",
	"req_fieldReq": "الحقل مطلوب",
	"req_maxlev": "الحد الأقصى للرافعة المالية المسموح به للاستفادة من مكافأة الإيداع بنسبة 100٪ هو 300X. ",
	"req_tochangeleverage": "لتغيير الرافعة المالية",
	"req_bonusMsz2": "تمت إضافة المكافأة بنجاح ل معرف التداول:",
	"req_availBonus": "استخدام المكافأة",
	"req_allowBonus": "المكافأة المسموح بها",
	"req_goBackMangeAcc": "الانتقال إلى إدارة الحساب",
	"req_noTradingAccFound": "لا يوجد حساب تداول حقيقي!",
	"req_minBonus": "الحد الأدنى لمكافأة الإيداع هو 200 دولار ونحن نحصل على خيار الإيداع",
	"req_maxAmount": "الحد الأقصى للمبلغ الذي يمكنك طلبه للحصول على مكافأة هو ",
	"rb_ReadPolicy": "اقرأ سياسة المكافأة الخاصة بنا",
	"dep_acc_fund_depFundAcc": "إيداع الأموال إلى الحساب",
	"dep_acc_fund_tradAccId": "معرف حساب التداول",
	"dep_acc_fund_depFund": "إيداع الأموال",
	"dep_acc_fund_selDepMet": "تحديد طريقة الإيداع",
	"dep_acc_fund_depFieldReq": "حقل طريقة الإيداع مطلوب",
	"dep_selectbankaccount": "يرجى تحديد الحساب البنكي :",
	"dep_acc_fund_lessDet": "تفاصيل أقل",
	"dep_acc_fund_viewDet": "عرض التفاصيل",
	"dep_holderName": "اسم صاحب الحساب",
	"dep_sortCode": "رمز الفرز",
	"dep_reference": "مرجع",
	"dep_fortradaccount": "لحساب التداول",
	"dep_selectAcc": "الرجاء تحديد الحساب",
	"dep_acc_fund_DontbankAcc": "ليس لديك أي حساب مصرفي، من فضلك",
	"dep_acc_fund_clkHere": "اضغط هنا",
	"dep_Createbank": "لإنشاء بنك جديد",
	"dep_acc_fund_MinDepAmt": "الحد الأدنى لمبلغ الإيداع",
	"dep_acc_fund_SpeDepAm": "تحديد مبلغ الإيداع",
	"dep_mindepositallow": "الحد الأدنى للإيداع المسموح به",
	"dep_acc_fund_bakStp": "الخطوة السابقة",
	"dep_acc_fund_procToPay": "المتابعة للدفع",
	"dep_ticketHasbeenCreated": "تم إنشاء تذكرتك",
	"dep_proMsz19": "الذهاب إلى التذاكر",
	"dep_acc_fund_PlsEnsCort": "الرجاء التأكد من صحة التفاصيل",
	"dep_acc_fund_accountId": "رقم حساب/محفظة",
	"dep_acc_fund_feeUsd": "الرسوم (دولار أمريكي)",
	"dep_acc_fund_depAmt": "مبلغ الإيداع",
	"dep_acc_fund_depMeth": "طريقة الإيداع",
	"dep_acc_fund_noTrdAccFnd": "لا يوجد حساب تداول مباشر!",
	"dep_acc_fund_plzWaitWhileProc": "يرجى الانتظار بينما نحن معالجة البيانات الخاصة بك...",
	"dep_maxlimit": "قمت برفع الحد الأقصى للمعاملة شهريا",
	"dep_maxdeposit": "يمكنك إيداع الحد الأقصى للمبلغ = ",
	"dep_pleaseDeposit": "أريد إيداع",
	"dep_pleaseDeposit1": "من قبل التفاصيل المصرفية على النحو المذكور أدناه <br>",
	"dep_AccNumber": "رقم الحساب : ",
	"dep_holdername": "<br> اسم صاحب الحساب :",
	"dep_bankname": "<br> اسم البنك :",
	"dep_brsortCode": "<br> رمز الفرز :",
	"dep_brbankAdress": "<br> عنوان البنك :",
	"dep_depositDone": "الإيداع تم بنجاح",
	"dep_depositFail": "فشل الإيداع",
	"dl_depositList": "قائمة الإيداع",
	"dl_transId": "معرف الحركة",
	"dl_status": "حالة",
	"dl_Method": "طريقة",
	"dl_type": "نوع",
	"dl_created": "تاريخ",
	"dl_action": "فعل",
	"dt_depTransHist": "سجل معاملات الإيداع",
	"dt_payMeth": "طريقة الدفع",
	"dt_clickToResolve": "انقر لحل",
	"dw_acc_fund_selDepMet": "تحديد طريقة الإيداع",
	"dw_acc_fund_depFieldReq": "حقل DepositMethod مطلوب",
	"dw_selectaccount": "يرجى تحديد الحساب البنكي :",
	"dw_acc_fund_lessDet": "تفاصيل أقل",
	"dw_acc_fund_viewDet": "عرض التفاصيل",
	"dw_holderName": "اسم صاحب الحساب:",
	"dw_bankName": "اسم البنك:",
	"dw_bankAdd": "عنوان البنك:",
	"dw_sortCode": "رمز الفرز",
	"dw_reference": "مرجع",
	"dw_fortradingAcc": "لحساب التداول",
	"dw_acc_fund_DontbankAcc": "ليس لديك أي حساب مصرفي، من فضلك",
	"dw_Createbank": "لإنشاء بنك جديد",
	"dw_acc_fund_MinDepAmt": "الحد الأدنى لمبلغ الإيداع",
	"dw_acc_fund_SpeDepAm": "تحديد مبلغ الإيداع",
	"dw_acc_fund_PlsEnsCort": "الرجاء التأكد من صحة التفاصيل",
	"dw_acc_fund_accountId": "معرف الحساب",
	"dw_acc_fund_feeUsd": "الرسوم (دولار أمريكي)",
	"dw_acc_fund_depAmt": "مبلغ الإيداع",
	"dw_acc_fund_depMeth": "طريقة الإيداع",
	"dw_proMsz19": "الذهاب إلى التذاكر",
	"dw_acc_fund_plzWaitWhileProc": "يرجى الانتظار بينما نحن معالجة البيانات الخاصة بك...",
	"dw_bankCode": "<br> كود البنك : ",
	"acc_reqProcessing": "معالجة الطلب...",
	"acc_accountVerMsz1": "تمت معالجة الطلب بنجاح",
	"acc_backAccountList": "العودة إلى قائمة الحسابات",
	"acc_reqFailed": "فشل الطلب",
	"acclist_myAccounts": "حساباتي",
	"acclist_liveAccount": "حسابات مباشرة",
	"acclist_demoAccount": "الحسابات التجريبية",
	"lev_changeLeverage": "تغيير الرافعة المالية",
	"lev_exsistLev": "الرافعة المالية الحالية",
	"lev_newLev": "الرافعة المالية الجديدة",
	"lev_backManageAccount": "العودة إلى إدارة الحساب",
	"lev_levMsz1": "يرجى النقر على الرابط لتغيير الرافعة المالية الخاصة بك.",
	"lev_levMsz2": "تم تغيير الرافعة المالية لحساب التداول بنجاح",
	"lev_tradingId": "أفكار التداول",
	"lev_oldLev": "الرافعة المالية القديمة",
	"lev_goBackMangeAccv": "الانتقال إلى إدارة الحساب",
	"lev_noDemoLiveTradingAccFound": "لم يتم العثور على حساب تداول!",
	"lev_waitforVerf": "الرجاء الانتظار حتى التحقق.",
	"levPwd_passMsz1": "الرجاء الضغط على الرابط لتغيير كلمة المرور",
	"lePwd_passMsz2": "تم تغيير كلمة مرور حساب التداول بنجاح",
	"lePwd_oldPassword": "كلمة المرور القديمة",
	"Dlist_demoLive": "عرض توضيحي/ بث مباشر",
	"Dlist_accountType": "نوع الحساب",
	"Dlist_leverage": "الرافعة",
	"detch_detachaccount": "حساب فصل:",
	"detch_fourfive": "454579",
	"detch_pamMaster": "Pamm master:",
	"detch_todd": "Todd Anderson",
	"detch_balance": "رصيد",
	"detch_equity": "الهامش",
	"detch_freeMargin": "هامش حر",
	"detch_MarginUSed": "الهامش المستخدم",
	"detch_pnl": "الربح و الخسارة",
	"detch_two": "$2,000 ",
	"detch_eight": "$800 ",
	"detch_twelve": "$1,200 ",
	"detch_three": "$300 ",
	"detch_twofive": "($250)",
	"detch_takenote": "يرجى الإحاطة علما بالنقاط أدناه",
	"detch_openPosition": "سيتم إغلاق جميع المراكز المفتوحة قبل فصل الحساب.",
	"detch_finalPnl": "قد يختلف الربح او الخسارة النهائي وفقا لظروف السوق",
	"detch_afterOpen": "بعد إغلاق المراكز المفتوحة، سيتم حساب الإدارة، تكلفة الاشتراك، رسوم الأداء وخصمها من الحساب، إن وجدت.",
	"detch_terms": "أقبل الشروط والأحكام المذكورة أعلاه",
	"detch_confirm": "أكد",
	"It_oneRecord": "لديك سجل واحد فقط يرجى إنشاء حساب تداول واحد على الأقل أو محفظة قبل محاولة التحويل الداخلي",
	"It_liveAcc": "حساب حقيقي",
	"It_wallet": "محفظة",
	"It_internalTransfer": "النقل الداخلي",
	"It_confToTransfer": "الرجاء تأكيد المتابعة",
	"It_back": "الخلف",
	"It_freeMargin": "هامش حر",
	"It_interTransSorryMsz": "عذرا ليس لديك رصيد لتحويل المبلغ إلى حساب تداول آخر.",
	"It_transToAcc": "التحويل إلى معرف الحساب",
	"It_fieldReq": "الحقل مطلوب",
	"It_currentBalance": "الرصيد الحالي",
	"It_pleseEnterAmount": "الرجاء إدخال المبلغ",
	"It_submit": "إرسال",
	"It_intTransMsz2": "الرجاء الضغط على الرابط لتأكيد نقلك الداخلي",
	"It_intTransMsz3": "تم إتمام عملية النقل بنجاح",
	"It_fromTradId": "من معرف التداول",
	"It_towallet": "إلى المحفظة",
	"It_toTradId": "إلى معرف التداول",
	"It_transferAmount": "المبلغ المحول",
	"It_backinternalTrans": "العودة إلى النقل الداخلي",
	"It_interTransDeducted": "سيتم خصم من الخاص بك",
	"It_depostotradAcc": "سيتم إيداعها في الخاص بك",
	"Itwallet_backwallet": "العودة إلى المحفظة",
	"Itwallet_cancel": "إلغاء الأمر",
	"Itwallet_fromwal": "من المحفظة",
	"Itwallet_towal": "إلى المحفظة",
	"Itwallet_backtowallet": "العودة إلى المحفظة",
	"sub_SubliveAcc": "الاشتراك في حساب مباشر",
	"sub_subscribe": "اشترك",
	"sub_backtradingTool": "العودة إلى مربع أداة التداول",
	"sub_enterotp": "أدخل Otp",
	"sub_validate": "التحقق",
	"sub_resendOtp": "إعادة إرسال أوتب",
	"sub_congo": "مبروك",
	"sub_tradingId": "معرف التداول",
	"sub_addtradertool": "يرجى إضافة مربع أداة التاجر لكل التفاصيل التالية <br> account_id : ",
	"re_marketinsight": "رؤى السوق",
	"re_news": "خبر",
	"edu_learnTrade": "تعلم كيفية التداول",
	"edu_offerEdu": "نحن نقدم لك الموارد التعليمية لمعرفة كل شيء عن التداول. تلبي موادنا التعليمية جميع مستويات المعرفة، وتمكنك من تعزيز فهمك للأسواق العالمية والتداول عبر الإنترنت وأدوات التداول لدينا. تتراوح قائمة التداول الشاملة بين الأساسية والمتقدمة، وسوف تساعدك على رفع مستوى التداول الخاص بك إلى مستوى أعلى.",
	"edu_Enhance": "عزز من فهمك للأسواق العالمية و خذ تداولك إلى المستوى التالي من خلال الاستفادة من مواردنا التعليمية. يقدم برنامج Fxview Education قائمة واسعة من الموضوعات التي تلبي احتياجات جميع مستويات المتداولين - من المبتدئين إلى المتقدمين - ويغطي كيفية عمل الأسواق ، وكذلك كيفية استخدام أدوات التداول الخاصة بنا لصالحك.",
	"edu_tradeconfidence": "سوف تتعلم التداول بثقة من خلال التركيز على الجوانب التقنية والأساسية للتداول / الاستثمار بمساعدتنا ودعمنا في جميع أنحاء",
	"edu_basic": "أساسي",
	"edu_advance": "متقدم",
	"edu_general": "عام",
	"edu_forex": "الفوركس",
	"edu_commodities": "السلع الاساسيه",
	"edu_indices": "مؤشرات",
	"edu_stocks": "أسهم",
	"edu_thereIsNoRecord": "لم يتم العثور على سجلات",
	"marin_source": "المصدر: الأطواقAI",
	"marin_loadmore": "تحميل المزيد",
	"marin_loadwait": "تحميل الرجاء الانتظار...",
	"news_marketnews": "أخبار السوق",
	"news_fearurednews": "الأخبار المميزة",
	"news_market": "سوق",
	"news_nodata": "لا توجد بيانات",
	"news_latestnews": "آخر الأخبار",
	"video_video": "فيديو",
	"video_tut": "الدروس",
	"video_intrestedforex": "هل تداول الفورك الفوركات يثير إهتمامك؟ أنت في المكان الصحيح. Fxview تقدم سلسلة من دروس الفيديو لمساعدتك على تطوير المهارات الخاصة بك وتعلم التجارة مثل الايجابيات. تتضمن تعليمات خطوة بخطوة  حول التسجيل والتحقق من الحساب ومصطلحات الفوركس الأساسية ووظائف منصة التداول وغيرها الكثير.",
	"video_allvideo": "كل الفيديوهات",
	"video_fxviewtut": "دروس Fxview",
	"video_platTut": "دروس المنصة",
	"video_forexBasic": "أساسيات الفورك الفورك",
	"video_whatisforex": "ما هو الفورسك",
	"web_webinars": "ندوات عبر الإنترنت",
	"web_enhancetrad": "عزز التداول الخاص بك من خلال الاشتراك في ندوات الويب المجانية والتعلم من الخبراء. صممت ندواتنا الإلكترونية خصيصا لتعزيز معرفتك بالسوق وصقل مهارات التداول الخاصة بك. يكشف الخبراء عن استراتيجيات ومفاهيم التداول الرئيسية، والتي يمكن أن تفيد كل من المبتدئين والتجار ذوي الخبرة.",
	"web_registeran": "سجل للحصول على",
	"web_upcomingweb": "ندوة الويب القادمة",
	"web_register": "سجل",
	"web_timeleft": "الوقت المتبقي",
	"web_days": "أيام",
	"web_hours": "ساعات",
	"web_mins": "دقائق",
	"web_secs": "ثواني",
	"web_webnar": "ويبينار",
	"web_library": "مكتبة",
	"web_higherpower": "خطوط الاتجاه- الويبينار",
	"web_aprtwenty": "(9 أغسطس 2021)",
	"web_findright": "الدعم والمقاومة- الويبينار",
	"web_aprsixteen": "(11 أغسطس 2021)",
	"web_weekahead": "المؤشرات الأساسية- الويبينار",
	"web_aprtwelve": "(13 أغسطس 2021)",
	"web_introTrend": "مقدمة لمؤشرات الاتجاه - الويبينار",
	"web_apreighteen": "مارس 18",
	"web_topicdiscuss": "موضوع المناقشة",
	"web_correlation": "FXVIEW باستخدام الارتباط لتحسين التداول الخاص بك",
	"web_datemay": "11 مايو 2021 12:00 - 12:40 مساء بتوقيت جرينتش",
	"web_showlocal": "إظهار وقتي المحلي",
	"web_joinfxview": "انضم إلى خبير Fxview لأنه يعطيك رؤى حول استخدام الارتباط من أجل تحسين مهارات التداول الخاصة بك.",
	"web_secureplace": "أمن مكانك مع خبير في الصناعة وتعلم ما يلزم ليكون تاجر فوركات محترف",
	"web_topicsCovered": "المواضيع التي سيتم تغطيتها خلال الندوة عبر الإنترنت",
	"web_strongweak": "#NAME?",
	"web_corrmultiple": "#NAME?",
	"web_posneg": "#NAME?",
	"ForexGlossarySpan": "<span>مسرد الفورك الفورك</span>",
	"ForexGlossaryGuide": "يعد مسرد الفوركس في Fxview دليلا كاملا لمساعدتك على تعلم مصطلحات الفوركس الأساسية والتعرف على لغة المتداول.",
	"AGGREGATE_DEMAND": "الطلب الكلي",
	"text": "وهو مقياس اقتصادي للطلب الإجمالي على جميع السلع والخدمات النهائية في الاقتصاد/القطاع. وهو يشير إلى كيفية ارتباط مستويات الأسعار الحالية بالناتج المحلي الإجمالي الحقيقي للدولة ™(الناتج المحلي الإجمالي).",
	"APPRECIATION": "التقدير",
	"AppText": "ويشير إلى زيادة في قيمة عملة واحدة مقارنة بعملة أخرى استجابة لطلب السوق.",
	"ARBITRAGE": "التحكيم",
	"ArbText": "شراء الأصول المالية في سوق واحدة وبيع المتزامنة في سوق أخرى للاستفادة من الفروق في الأسعار يعرف باسم المراجحة.",
	"AROUND": "حول",
	"ArndText": "تاجر المصطلحات المستخدمة في الاقتباس عندما قسط إلى الأمام / الخصم هو بالقرب من التكافؤ. على سبيل المثال ، â € œtwo - two aroundâ € سيترجم إلى نقطتين على جانبي المكان الحالي.",
	"ASK_RATE": "سعر الطلب",
	"Asktext": "السعر/السعر الذي يتم به عرض أداة مالية للبيع.",
	"ASSET_ALLOCATION": "توزيع الأصول",
	"AsstText": "استراتيجية استثمارية تهدف إلى تحقيق التوازن بين المخاطر والمكافأة من خلال تخصيص الأموال لمختلف الأسهم والسندات والسلع والعملات وفئات الأصول الأخرى وفقا لأهداف المستثمرين.",
	"Back_office": "المكتب الخلفي",
	"BalanceofTrade": "الميزان التجاري",
	"BarCharts": "المخططات الشريطية",
	"BaseCurrency": "العملة الأساسية",
	"BearMarket": "سوق الدب",
	"BidRate": "سعر العرض",
	"btext1": "تقوم الإدارات بالتحقق من جميع عمليات التسوية والعمليات ذات الصلة",
	"btext2": "الفرق في القيمة بين صادرات البلد ™ووارداته.",
	"btext3": "وتستخدم الرسوم البيانية الشريطية في الأسواق المالية لنقل تحركات الأسعار إلى مخطط سهل القراءة. وهي في الأساس مخطط رسومي OHLC المستخدمة لرسم الأسعار. هناك علامة على الرسم البياني الذي يوفر السعر فترة زمنية معينة في فتح وارتفاع وانخفاض وإغلاق.",
	"btext4": "عملة تظهر في عرض أسعار زوج الفوركات. هناك دائما عملة واحدة في سوق الفوركات التي يتم اقتباسها دائما فيما يتعلق بعملة أخرى حيث تقوم بشراء واحدة أثناء بيع الأخرى. ستظهر العملة الأساسية أولا، تليها العملة الثانية (عرض الأسعار). على سبيل المثال، إذا كنت تبحث في زوج اليورو / الدولار الأمريكي، وهنا العملة الأساسية هي اليورو والعملة الاقتباس هو الدولار الأمريكي.",
	"btext5": "سوق تتميز بانخفاض الأسعار.",
	"btext6": "الحد الأقصى للسعر الذي يرغب المشتري في دفعه.",
	"CABLE": "كبل",
	"CABLEText": "كنية تستخدم لزوج GBP/USD. نشأ المصطلح بسبب حقيقة أن السعر كان ينتقل في الأصل عبر كبل عبر الأطلسي بداية من منتصف عام 1800 ، ™عندما كان الجنيه الإسترليني عملة التجارة الدولية.",
	"CANDLESTICK_CHART": "مخطط الشمعدان",
	"CANDLESTICK_CHARTText": "وتسمى أيضا الرسم البياني الشمعدان الياباني، هو نوع من الرسم البياني الشريطي المستخدمة أساسا لوصف تحركات سعر ورقة مالية، مشتق أو العملة. كل € € œcandlestickâ € يظهر عادة يوم واحد ويمثل الفرق بين سعر الافتتاح والإغلاق. إذا كان سعر الفتح أعلى من سعر الإغلاق، فإن الشمعة/المستطيل مظلل. إذا كان سعر الإغلاق أعلى من سعر الفتح، فإن منطقة المخطط غير مظللة.",
	"CENTRAL_BANK": "البنك المركزي",
	"CENTRAL_BANKText": "حكومة أو منظمة شبه حكومية تشرف على سياسات نقدية وطباعة ™العملات. على سبيل المثال ، بنك الاحتياطي الفيدرالي (الولايات المتحدة) ، البنك المركزي الأوروبي (أوروبا) ، بنك الاحتياطي الأسترالي (أستراليا).",
	"CHARTISTs": "مخطط",
	"CHARTISTsText": "فرد (يعرف أيضا باسم المتداول التقني) يستخدم الرسوم البيانية والرسوم البيانية لتفسير البيانات التاريخية من أجل العثور على الاتجاهات والتنبؤ بتحركات الأسعار المستقبلية.",
	"CHOICE_MARKET": "سوق الاختيار",
	"CHOICE_MARKETText": "يشار إليها أيضا باسم السوق المقفلة ، إنها سوق بدون انتشار. وهذا يعني أنه يمكن شراء العملة بنفس السعر الذي يمكن بيعها به في السوق.",
	"CLEARING": "مسح",
	"CLEARINGtext": "عملية التوفيق بين أو تسوية المشتريات والمبيعات من مختلف الأدوات المالية.",
	"CONTAGION": "عدوى",
	"CONTAGIONText": "الميل إلى أزمة اقتصادية للانتشار من سوق إلى أخرى.",
	"COLLATERAL": "ضمانات",
	"COLLATERALText": "شيء معين من قبل المقترض لتأمين قرض أو كضمان للأداء.",
	"COMMISSIONs": "مهمة",
	"COMMISSIONText": "رسم معاملة يفرضه الوسيط من المتداولين/ المستثمرين. ",
	"CONFIRMATION": "تأكيد",
	"CONFIRMATIONText": "المستندات التي يتم تبادلها من قبل النظراء إلى معاملة تنص على شروط المعاملة المذكورة.",
	"CONTRACTunit": "العقد (وحدة أو الكثير)",
	"CONTRACTunitText": "الوحدة القياسية للتداول.",
	"COUNTERPARTY": "الطرف المقابل",
	"COUNTERPARTYText": "أحد المشاركين، إما بنك أو عميل، يتم إجراء معاملة مالية معه.",
	"COUNTRY_RISK": "مخاطر البلد",
	"COUNTRY_RISKText": "المخاطر المرتبطة بالمعاملات عبر الحدود مثل الظروف القانونية والسياسية مثل الحرب. ",
	"CROSS_RATES": "الأسعار المتقاطعة",
	"CROSS_RATESText": "أسعار الصرف بين عملتين لا تنطويان على الدولار الأمريكي. ويقال إن سعر الصرف المتبادل غير قياسي في البلد الذي يتم فيه تسعير زوج العملات.",
	"CURRENCYe": "عملة",
	"CURRENCYText": "وسيلة تبادل في شكل ورق أو معدن أو رقمي صادرة عن حكومة/مصرف مركزي وتستخدم كمناقصة قانونية. ",
	"CURRENCY_RISK": "مخاطر العملة",
	"CURRENCY_RISKText": "مخاطر تكبد خسائر بسبب التغير السلبي في أسعار الصرف.",
	"Day_trading": "التداول اليومي",
	"Day_tradingText": "استراتيجية تداول تتضمن فتح وإغلاق مراكز خلال نفس اليوم.",
	"Dealer": "تاجر",
	"DealerText": "الشخص الذي يعمل كمدير أو نظير لمعاملة. الرئيسية أساسا على جانب واحد على أمل كسب ربح جيد عن طريق إغلاق المركز في تجارة لاحقة مع طرف آخر.",
	"Deficit": "عجز",
	"DeficitText": "مبلغ تتجاوز تكلفة واردات البلدان بموجبه تكلفة صادراتها أو تسمى أيضا ميزانا تجاريا سلبيا.",
	"Delivery": "تسليم",
	"DeliveryText": "تسوية معاملة عن طريق تسليم الأموال. أو تاريخ استحقاق العقد، عندما تتم التسوية النهائية للمعاملة عن طريق تبادل العملات.",
	"Depreciation": "الاهلاك",
	"DepreciationText": "انخفاض قيمة العملة ™بالنسبة لعملة أخرى إما بسبب ظروف السوق أو عوامل أخرى.",
	"Derivative": "مشتق",
	"DerivativeText": "تستمد المشتقات قيمتها من سعر الأصل الأساسي وغالبا ما يستخدمها المتداولون كأداة للمضاربة على تحركات سعر الأصل في المستقبل دون الحاجة إلى شراء الأصل نفسه. الخيار هو الأداة المشتقة الأكثر شيوعا.",
	"Devaluation": "التخفيض",
	"DevaluationText": "تنخفض قيمة العملة عند انخفاض قيمة العملة ™مقابل عملة أخرى أو أكثر.",
	"ECONOMIC_INDICATOR": "مؤشر اقتصادي",
	"ECONOMIC_INDICATORText": "إجراء إحصائي صادر عن الحكومة أو مؤسسة غير حكومية يشير إلى الحالة الاقتصادية لاقتصاد مثل الناتج المحلي الإجمالي والاستثمار الأجنبي والعجز التجاري ومعدلات التوظيف وما إلى ذلك.",
	"ENDOFDAYORDER": "أمر نهاية اليوم",
	"ENDOFDAYORDERText": "أمر الشراء أو البيع بسعر محدد مفتوح فقط حتى نهاية يوم التداول، عادة 5 مساء/17:00 بتوقيت نيويورك.",
	"EUROs": "يورو",
	"EUROsText": "عملة الاتحاد النقدي الأوروبي (الاتحاد النقدي الأوروبي).",
	"EUROPEANCENTRALBANK": "البنك المركزي الأوروبي",
	"EUROPEANCENTRALBANKText": "تأسس في عام 1998، وهو البنك المركزي للاتحاد النقدي الأوروبي (EMU).",
	"FederalDepositInsurance": "المؤسسة الاتحادية للتأمين على الودائع (FDIC)",
	"FederalDepositInsuranceText": "وكالة فيدرالية مستقلة تحمي المستهلكين والنظام المالي الأميركي. مؤسسة الاستثمار الأجنبي المباشر هي أشهر شركة للتأمين على الودائع لأنها تساعد العملاء على تجنب الخسائر في حالة فشل البنوك.",
	"FederalReserveSystem": "نظام الاحتياطي الفيدرالي",
	"FederalReserveSystemText": "أقوى مؤسسة مالية في العالم. أسس الكونغرس الأميركي نظام الاحتياطي الفيدرالي في عام 1913 بهدف توفير نظام نقدي مستقر، ويضم وكالة حكومية مركزية و12 مصرفا إقليميا للاحتياطي الفيدرالي.",
	"FixedExchangeRate": "سعر الصرف الثابت",
	"FixedExchangeRateText": "نظام سعر الصرف حيث يتم تعيين قيمة العملة ™من قبل السلطات النقدية مقابل قيمة عملة واحدة أو أكثر.",
	"FloatingExchangeRate": "سعر الصرف العائم",
	"FloatingExchangeRateText": "نظام سعر الصرف حيث يتم تحديد قيمة العملة ™من قبل سوق الفوركات على أساس الطلب والعرض بالنسبة للعملات الأخرى.",
	"Flatsquare": "مسطح/مربع",
	"FlatsquareText": "تاجر المصطلحات المستخدمة لوصف الموقف الذي تم عكس تماما. على سبيل المثال ، اشتريت 100،000 دولار ثم باعت 100،000 دولار ، وبالتالي إنشاء مركز مسطح.",
	"Foreign_Exchange": "النقد الأجنبي",
	"Foreign_ExchangeText": "النقد الأجنبي هو تبادل عملة واحدة مقابل الأخرى. وهي الشبكة العالمية على الإنترنت حيث يقوم المتداولون بشراء وبيع العملات. وليس لها موقع مادي وتعمل على مدار الساعة.",
	"Forward": "أمامي",
	"ForwardText": "سعر محدد مسبقا لتأمين سعر في وقت مستقبلي محدد، استنادا إلى فرق سعر الفائدة بين العملتين المعنيتين.",
	"Forward_Contracts": "العقود الآجلة",
	"Forward_ContractsText": "اتفاق بين الطرفين لشراء أو بيع أصل بسعر محدد في تاريخ انتهاء محدد مسبقا. وكلا الطرفين ملزمان بالوفاء بطرفهما من الاتفاق.",
	"ForwardRates": "الأسعار (المقايضات)",
	"ForwardRatesText": "السعر الي الأمامى هو سعر نقدى لفارق فائدة بعملتين لفترة محددة ويمكن حسابه بسهولة شريطة أن يتم تحديد أسعار الفائدة الثابتة لكل عملة ويتم إعطاء السعر الفورى الحالى.",
	"Forward_Trading": "التداول إلى الأمام",
	"Forward_TradingText": "التداول إلى الأمام هو جعل التجارة المعاكسة للتجارة الفورية في وقت معين. غالبا ما يقوم المتداولون بتبديل صفقاتهم إلى الأمام بدءا من أسبوع إلى أشهر. على الرغم من أن العقد الآجل يحدث في تاريخ مستقبلي، إلا أنه لا يزال من الممكن إغلاق المركز في أي وقت. ثم يتم تبديل الجزء الختامي من المركز إلى نفس تاريخ القيمة المستقبلية.",
	"Forwardpoints": "نقاط أمامية",
	"ForwardpointsText": "ببساطة النقاط التي تضاف أو تطرح من سعر الصرف الحالي لحساب سعر أمامي.",
	"Fundamental_Analysis": "التحليل الأساسي",
	"Fundamental_AnalysisText": "طريقة تحليل العوامل التي قد تؤثر على السعر في المستقبل. ويستند هذا الشكل من التحليل على الأحداث والتأثيرات الخارجية وكذلك اتجاهات الصناعة حيث التجار التقنية تستمد المعلومات من الرسوم البيانية والأنماط.",
	"FuturesContract": "العقود الآجلة",
	"FuturesContractText": "اتفاق قانوني بين طرفين للتداول بسعر محدد مسبقا، في تاريخ محدد مسبقا في المستقبل. يتم تداول العقود الآجلة عبر البورصة ويمكن استخدامها للحصول على التعرض لمجموعة واسعة من الأصول.",
	"Gearing": "تستعد",
	"GearingText": "عندما يتداول المتداول على دين جزئي أو هامش.",
	"GroupofFive": "مجموعة الخمسة (G5)",
	"GroupofFiveText": "يذكر ان خمس دول صناعية كبرى وهى فرنسا واليابان والمملكة المتحدة والمانيا والولايات المتحدة تجتمع من وقت لاى وقت بهدف مناقشة المشكلات الاقتصادية المشتركة .",
	"GroupofSeven": "مجموعة السبعة (7)",
	"GroupofSevenText": "مجموعة السبعة هي 7 دول صناعية غير شيوعية رائدة تتألف من فرنسا وألمانيا والمملكة المتحدة وألمانيا والولايات المتحدة بالإضافة إلى كندا وإيطاليا. وهي تعرف الآن باسم مجموعة الثماني منذ إضافة روسيا.",
	"GroupofTen": "مجموعة العشرة (G10)",
	"GroupofTenText": "كما دعا â € \" نادي باريس € تتألف من كندا وبلجيكا وفرنسا وألمانيا وإيطاليا والسويد واليابان والمملكة المتحدة والولايات المتحدة وهولندا. وقد تم تشكيله في عام 1962 لإتاحة الأموال لصندوق النقد الدولي ومساعدة البلدان الأعضاء التي تواجه صعوبات في ميزان المدفوعات.",
	"GoldilocksEconomy": "جولديلوكس الاقتصاد",
	"GoldilocksEconomyText": "مصطلح يستخدم لوصف اقتصاد ليس حارا جدا أو باردا جدا ويحافظ على نمو معتدل مع معدل رمزي للتضخم ، يسمح بسياسة نقدية صديقة للسوق.",
	"GoodtilCancel": "جيد € \" تم إلغاء (GTC)",
	"GoodtilCancelText": "أمر صالح حتى يتم إلغاؤه أو إكماله بغض النظر عن مقدار الوقت الذي تم فيه وضع الطلب. ",
	"HEDGING": "التحوط",
	"HEDGINGText": "استراتيجية إدارة المخاطر حيث المستثمرين â € € œhedgeâ € ™ لحماية أنفسهم من تحركات الأسعار السلبية من خلال اتخاذ موقفين متعارضين ، وبالتالي الحد من المخاطر. في سياق معاملات العملة فإنه يحمي المرء من تقلبات سعر صرف العملات الأجنبية. ",
	"INFLATION": "تضخم",
	"INFLATIONText": "زيادة مستمرة في مستوى الأسعار العامة للسلع الاستهلاكية، مما يؤدي إلى تآكل القوة الشرائية.",
	"INITIALMARGIN": "الهامش الأولي",
	"INITIALMARGINText": "الإيداع الأولي للضمانات المطلوبة للدخول في مركز كضمان على الأداء المستقبلي.",
	"INTERBANKRATES": "أسعار الصرف بين البنوك",
	"INTERBANKRATESText": "أسعار الصرف الأجنبي التي تقتبس بها البنوك الدولية الكبيرة من البنوك الدولية الكبيرة الأخرى.",
	"LEADINGINDICATORS": "المؤشرات الرائدة",
	"LEADINGINDICATORSText": "المتغيرات الاقتصادية التي ينظر فيها للتنبؤ بالنشاط الاقتصادي في المستقبل.",
	"LEVERAGEs": "النفوذ",
	"LEVERAGEsText": "يتم تقديم الرافعة المالية من قبل الوسطاء لتحقيق أقصى قدر من القوة الشرائية. ™ ويمكن وصفها بأنها رأس المال ™ â € € من وجهة نظر التجار ويزيد من العوائد المحتملة الخاصة بك حيث يمكنك التداول أحجام أكبر بكثير مع هذه الأموال من رأس المال المحدود الخاص بك. يتم التعبير عنه بنسب مثل 1:100، 1:300 وهلم جرا. حتى مع رافعة مالية من 1:100 يتم تضخيم قوة شرائية traderâ € ™ ™ق 100 مرة. <strong>اخلاء المسؤوليه:</strong> الرافعة المالية تضخم العائدات المحتملة وكذلك الخسائر.",
	"LIBOR": "ليبور",
	"LIBORText": "عرض البنك الدولي في لندن السعر. وهو سعر الفائدة القياسي الذي تقرض به البنوك العالمية الكبرى بعضها البعض.",
	"LIMITORDER": "أمر الحد",
	"LIMITORDERText": "أمر لتنفيذ تداول بسعر محدد أو أفضل. على سبيل المثال، إذا كان السعر الحالي لليورو/الدولار الأمريكي هو 1.08502/1.08522، فإن أمر الشراء باليورو سيكون بسعر أقل من سعر السوق،1.0820.",
	"LINECHARTS": "المخططات الخطية",
	"LINECHARTSText": "مخطط أسعار يربط أسعارا مفردة (جميع أسعار الإغلاق) لفترة زمنية محددة. ",
	"LIQUIDITYs": "السيوله",
	"LIQUIDITYsText": "زوج العملات â € ™ ™ق القدرة على أن يتم شراؤها وبيعها في السوق دون التسبب في تغيير كبير في سعر الصرف.",
	"LIQUIDATION": "التصفيه",
	"LIQUIDATIONText": "إغلاق مركز موجود من خلال تنفيذ معاملة تعويضية.",
	"LONGPOSITION": "مركز طويل",
	"LONGPOSITIONText": "ويقال إن الموقف هو â € \"longâ € إذا ™ كان يرتفع في القيمة عندما ترتفع أسعار السوق. عندما يشتري المرء زوج عملة، يكون مركزه طويلا على هذا الزوج.",
	"Margins": "هامش",
	"MarginText": "الهامش هو مبلغ المال المطلوب للحفاظ على مركز الهامش مفتوحا. هذا هو الفرق بين القيمة الكاملة لصفقتك والأموال التي يتم إقراضها لك من قبل وسيط / مزود الرافعة المالية.",
	"MarginDeposit": "إيداع الهامش",
	"MarginDepositText": "إيداع الهامش هو المبلغ الأولي من المال الذي يحتاج التاجر إلى اخماده من أجل فتح مركز تداول رافعة مالية. ويمكن أيضا أن يعرف باسم الهامش الأولي، أو الإيداع أو الإيداع ببساطة.",
	"MarginCall": "استدعاء الهامش",
	"MarginCallText": "يمكن وصف استدعاء الهامش بأنه تنبيه / طلب / مكالمة من الوسيط الخاص بك لإعلامك بأن الهامش الخاص بك قد انخفض إلى أقل من الحد الأدنى وأن مركزك معرض لخطر تصفيته. لذلك، في مثل هذه الحالة الوسيط يطلب من العميل الإيداع في حسابه للحفاظ على الصفقات الحالية مفتوحة.",
	"MarketMaker": "صانع السوق",
	"MarketMakerText": "تاجر يحافظ على عرض ثابت وسعر طلب ومستعد لتقديم سوق من جانبين لأي أداة مالية.",
	"MarketRisk": "مخاطر السوق",
	"MarketRiskText": "التعرض للتغيرات في أسعار السوق.",
	"Marktomarket": "علامة إلى السوق",
	"MarktomarketText": "تعديل/ تقييم جميع المراكز المفتوحة وفقا لأسعار السوق الحالية.",
	"Maturity": "نضوج",
	"MaturityText": "تسوية أو تاريخ انتهاء صلاحية أداة مالية.",
	"NarrowMarket": "سوق ضيق",
	"NarrowMarketText": "سوق الصرف تتميز أيضا سوق رقيقة حيث يوجد عدد قليل من المشترين والبائعين والأسعار تميل إلى أن تكون متقلبة.",
	"Offer_s": "عرض",
	"OfferText": "نفس سعر الطلب ، السعر الذي يرغب التاجر في البيع به.",
	"Offsettingtransaction": "تعويض الحركة",
	"OffsettingtransactionText": "التعويض يمكن أن يعني إغلاق مركز لإلغاء أو تعويض بعض أو كل من مخاطر السوق من مركز مفتوح.",
	"OneCancelsOrder": "واحد يلغي الطلب الآخر (OCO)",
	"OneCancelsOrderText": "عند وضع أمر إيقاف وأمر حد وإذا تم تنفيذ أي من الأمرين سيتم إلغاء الأمر الآخر تلقائيا.",
	"Openorder": "فتح النظام",
	"OpenorderText": "أمر ليس له تاريخ انتهاء صلاحية محدد ويتم تنفيذه عند الوصول إلى سعر سوق محدد. وهي ترتبط عموما مع أوامر GTC.",
	"Open_position": "فتح الموضع",
	"OpenPositionText": "موقف لا يزال نشطا ولم يغلق أو يعكس بعد.",
	"OvertheCounter": "عبر العداد (OTC)",
	"OvertheCounterText": "تداول OTC هو للأوراق المالية لتلك الشركات التي ليست مدرجة في أي بورصة مركزية، وبالتالي يتم شراء وبيع هذه الأوراق المالية دون وصفة طبية، أي من خلال الوسطاء والتجار من القطاع الخاص، الذين يتفاوضون مباشرة مع المشترين والبائعين.",
	"Overnight": "خلال الليل ",
	"OvernightText": "تداول/مركز يبقى مفتوحا حتى يوم العمل التالي.",
	"Pip_s": "نقاط",
	"PipText": "أصغر كمية من التغيير في سعر الفوركس المعروض. تعرف معظم العملات الرئيسية نقطة على أنها المكان العشري الرابع، لذا فإن تغيير نقطة واحدة يعادل 0.0001 باستثناء الين الياباني حيث النقطة هي الرقم الثاني بعد النقطة العشرية.",
	"PoliticalRisk": "المخاطر السياسية",
	"PoliticalRiskText": "بسبب التغيرات أو عدم الاستقرار في سياسة الحكومة ، والأثر السلبي على المستثمرين € € ™ق المواقف / العائدات.",
	"PointFigureCharts": "مخططات النقاط والشكل",
	"PointFigureChartsText": "النقطة والشكل الرسم البياني doesnâ € ر ™تأخذ في الاعتبار الوقت والتركيز تماما على تحركات الأسعار والاتجاهات في الأصول.",
	"Position_s": "مركز",
	"PositionText": "المركز هو المصطلح المالي للتجارة التي هي إما نشطة حاليا وقادرة على تكبد خسارة / ربح يسمى مركز مفتوح أو التجارة التي تم إغلاقها مؤخرا المعروفة باسم المركز المغلق.",
	"Premium": "قسط",
	"PremiumText": " المبلغ الذي يتجاوز به السعر المستقبلي أو المستقبلي السعر الفوري.",
	"PriceTransparency": "شفافية السعر",
	"PriceTransparencyText": " توضيح الأسعار التي يمكن لكل مشارك في السوق الحصول عليها على قدم المساواة",
	"Quote_s": "كووت (Quote)",
	"QuoteText": "السعر الذي تم تداول الأصل به آخر مرة أو يمكن شراؤه أو بيعه حاليا واستخدامه للحصول على معلومات إضافية فقط.",
	"RATE_s": "معدل",
	"RATEText": "سعر عملة واحدة من حيث الأخرى، التي تتغير قيمها بالنسبة لكل مع مرور الوقت.",
	"RESISTANCE_s": "المقاومه",
	"RESISTANCEText": "مصطلح التحليل الفني الشائع الاستخدام الذي يشير إلى مستوى سعر محدد حيث سيكون للعملة القدرة على العبور. مثل هذا السعر بمثابة سقف.",
	"REVALUATION": "إعادة التقييم",
	"REVALUATIONText": "عكس تخفيض قيمة العملة، إعادة التقييم هو تعديل تصاعدي لسعر الصرف الرسمي لبلد ™ما نتيجة لتدخل البنك المركزي. ",
	"REVALUATIONRATES": "معدلات إعادة التقييم",
	"REVALUATIONRATESText": "هذه هي أسعار السوق المستخدمة كقيمة أساسية من قبل المتداولين لتقييم ما إذا كان قد تم تحقيق الربح / الخسارة لهذا اليوم أو بشكل عام. عادة ما يكون معدل إعادة التقييم هو سعر الإغلاق ليوم التداول السابق. ",
	"RISK_s": "خطر",
	"RISKText": "إمكانية تحقيق نتيجة سلبية مثل الأداء الناقص أو الفشل في تحقيق أهداف التداول / الاستثمار أو خسارة المال أو التغييرات السلبية. ",
	"RISKCAPITAL": "رأس مال المخاطر",
	"RISKCAPITALText": "مبلغ المال الذي يمكن للفرد استثماره، والذي لن يؤدي فقدانه إلى تغيير كبير في نمط حياته. ",
	"RISK_MANAGEMENT": "إدارة المخاطر",
	"RISKMANAGEMENTText": "جميع التقنيات والاستراتيجيات المستخدمة للتخفيف من المخاطر الكامنة في التجارة والاستثمار و /أو التحكم فيها مثل استخدام وقف الخسائر والتحوط والتنويع وما إلى ذلك. ",
	"ROLLOVER": "لفة أكثر",
	"ROLLOVERText": "إنه الإغلاق المتزامن للموقف المفتوح لتاريخ القيمة اليوم ™وفتح نفس المركز لليوم التالي ™في سعر يعكس فروق سعر الفائدة بين عملتين.",
	"ROLLOVERRATE": "معدل التمديد",
	"ROLLOVERRATEText": "الفائدة المدفوعة أو المكتسبة بين عشية وضحاها لحيازة المركز / الأسهم، اعتمادا على الهامش الثابت والمركز في السوق.",
	"SETTLEMENT": "استيطان",
	"SETTLEMENTText": "نقل ملكية أداة مالية إلى مشتر. تسوية تداول العملات قد تنطوي أو لا تنطوي على التبادل الفعلي لعملة إلى أخرى.",
	"SHORTPOSITION": "مركز قصير",
	"SHORTPOSITIONText": "ويقال إن المركز يكون قصيرا عندما يبيع المتداول الأوراق أولا بنية إعادة شرائها لاحقا عندما ينخفض السعر. ويتم اتخاذ مثل هذا الموقف عندما يعتقد أن الأسعار من المرجح أن تنخفض في المستقبل القريب.",
	"SLIPPAGE": "انزلاق",
	"SLIPPAGEText": "يحدث الانزلاق عندما يتغير توزيع عرض الأسعار/الطلب بين الوقت الذي يتم فيه طلب أمر حتى وقت تنفيذ الأمر. يحدث هذا عادة خلال فترات التقلب العالي ويحدث في جميع الأسواق مثل الأسهم والسندات والعملات والعقود الآجلة.",
	"SPOTNEXT": "بقعة / التالي",
	"SPOTNEXTText": "يعرف أيضا باسم يوم عمل â € œnext ، فإنه يدل على تسليم العملة المشتراة في يوم بعد التاريخ الفوري. وهي مقايضات قصيرة الأجل حيث يتم طرح العملة يوم آخر أي بعد بقعة. ",
	"SPOTPRICE": "السعر الفوري",
	"SPOTPRICEText": "سعر السوق الحالي للأداة المالية. ",
	"SPOTRATE": "بقعة (معدل)",
	"SPOTRATEText": "سعر الصرف الحالي الذي يمكن شراء أو بيع العملة به. هو السعر المعروض في سوق التجزئة مع عدم وجود تعديل لفارق سعر الفائدة. ",
	"SPOTTRADE": "التجارة الفورية",
	"SPOTTRADEText": "يشير إلى شراء وبيع منتج مالي للتسليم الفوري في تاريخ محدد. يعرف أيضا باسم المعاملة الفورية ويتم تسويتها عادة إلكترونيا. ",
	"Spread_s": "انتشار",
	"SpreadText": "يعني الفارق في التداول النطاق/الفرق بين سعر العرض وسعر الطلب المعروض لزوج العملات.",
	"Sterling": "الجنيه الاسترليني",
	"SterlingText": "مصطلح للجنيه البريطاني.",
	"StopLossOrder": "أمر إيقاف الخسارة",
	"StopLossOrderText": "نوع أمر لبيع عملة عندما يصل السعر إلى السعر المحدد أو ينخفض عنه. يستخدم هذا للحد من الخسارة، وعادة عندما لا يمكن رصد السعر بنشاط من قبل التاجر.",
	"StochasticOscillator": "مذبذب ستوشاستيك",
	"StochasticOscillatorText": "يشير مصطلح Stochastic إلى نقطة السعر الحالي بالنسبة لنطاقه السعري على مدى فترة من الزمن. مؤشر التذبذب العشوائي هو مؤشر التحليل الفني الشعبي الذي ينص على أنه خلال سوق التداول التصاعدي، تميل الأسعار إلى الإغلاق بالقرب من ارتفاعها والعكس بالعكس.",
	"SupportLevels": "مستويات الدعم",
	"SupportLevelsTexts": " يشير هذا المصطلح إلى مستوى سعر محدد حيث سيكون للعملة القدرة على العبور أدناه. يحدث الدعم عندما يتوقف انخفاض الأسعار، ويغير الاتجاه ويبدأ في الارتفاع. غالبا ما ينظر إلى مستوى الدعم على أنه â € € œfloorâ € وهو دعم أو رفع الأسعار.",
	"Swap_s": "مبادله",
	"SwapText": "المبادلة هي عقد مشتق يتبادل من خلاله طرفان التدفقات النقدية أو الخصوم الناشئة عن أداتين ماليتين مختلفتين.",
	"Swift": "سويفت",
	"SwiftText": "جمعية الاتصالات المالية العالمية بين البنوك. وهي توفر شبكة حاسوبية مخصصة تمكن المؤسسات المالية في جميع أنحاء العالم من دعم رسائل تحويل الأموال في بيئة آمنة وموحدة وموثوقة.",
	"TECHNICALANALYSIS": "التحليل الفني",
	"TECHNICALANALYSISText": "وهو ينطوي على استخدام مختلف المؤشرات التقنية وتحليل عمل السوق من خلال دراسة الرسوم البيانية والحجم والاتجاهات والأنماط والمتوسطات المتحركة ومختلف المؤشرات التقنية الأخرى بهدف التنبؤ بالأسعار.",
	"TICK_s": "تك",
	"TICKText": "يمثل القراد أي عرض أسعار واحد قادم، صعودا أو أسفلا.  ",
	"TICKER": "شريط",
	"TICKERText": "يظهر التاريخ الحالي أو الحديث لعملة إما بتنسيق جدول أو رسم بياني.",
	"TOMORROWNEXT": "غدا التالي (توم / التالي)",
	"TOMORROWNEXTText": "هو شراء وبيع العملة في وقت واحد للتسليم في اليوم التالي.",
	"TRADING_s": "التجاره",
	"TRADINGText": "فعل الشراء أو البيع أو تبادل الأسهم أو السندات أو العملات إلخ.",
	"TRANSACTIONCOST": "تكلفة الحركة",
	"TRANSACTIONCOSTText": "تكلفة شراء وبيع أداة مالية.",
	"TRANSACTIONDATE": "تاريخ الحركة",
	"TRANSACTIONDATEText": "التاريخ الذي تحدث فيه عملية تداول.",
	"TREND_s": "الاتجاه",
	"TRENDText": "الاتجاه هو ببساطة ميل السعر للتحرك في اتجاه معين ، صعودا / أسفل / عكس / جانبية. وعادة ما يتم تقسيمها إلى ثلاث فئات â € \" الاتجاهات الرئيسية والمتوسطة والقصيرة الأجل. ",
	"TRENDLINE": "خط الاتجاه",
	"TRENDLINEText": " هذا هو مؤشر تقني شائع الاستخدام للكشف عن الاتجاهات. يربط خط الاتجاه بين اثنين أو أكثر من الارتفاعات المنخفضة أو أكثر مع الخطوط المتوقعة في المستقبل. يتم حسابها باستخدام â € € œleast المربعات methodâ € ويسمى أيضا الانحدار الخطي.",
	"TURNOVER": "دوران",
	"TURNOVERText": "هو القيمة الإجمالية للأموال لكافة الحركات المنفذة في فترة زمنية معينة. ",
	"TWOWAYPRICE": "سعر اتجاهين",
	"TWOWAYPRICEText": "يشير عرض أسعار ثنائي الاتجاه إلى سعر العرض الحالي وسعر الطلب الحالي لوامن في يوم تداول.",
	"UPTICK": "UPTICK",
	"UPTICKText": "يحدث ارتفاع عندما يرتفع سعر securityâ € ™ ™ق بالنسبة إلى القراد الماضي. وهو سعر جديد بسعر أعلى من عرض الأسعار السابق. ",
	"UPTICKRULE": "قاعدة UPTICK",
	"UPTICKRULEText": "تقييد التداول في الولايات المتحدة الذي ينص على أن البيع على المكشوف مسموح به فقط على ارتفاع. وفقا للقاعدة، لا يجوز بيع الأوراق التجارية قصيرة ما لم تكن آخر صفقة قبل البيع القصير بسعر أقل من السعر الذي يتم به البيع على المكشوف.",
	"USPRIMERATE": "سعر الفائدة الرئيسي للولايات المتحدة",
	"USPRIMERATEText": "سعر الفائدة الذي ستقرض به البنوك الأمريكية عملائها الرئيسيين من الشركات.",
	"VALUEDATE": "تاريخ القيمة",
	"VALUEDATEText": "التاريخ الذي يوافق فيه النظراء على تسوية التزاماتهم. بالنسبة لحركات العملة الفورية، يكون تاريخ القيمة عادة يومين عمل إلى الأمام. ويعرف أيضا باسم تاريخ الاستحقاق، وهو التاريخ الذي تتم فيه تسوية الحركة. ",
	"VARIATIONMARGIN": "هامش التباين",
	"VARIATIONMARGINText": "يجب على متداولي الصناديق الاحتفاظ بحساباتهم للحفاظ على تداول الرافعة المالية مفتوحا.  يشير المصطلح عادة إلى الأموال الإضافية التي يجب إيداعها نتيجة لتحركات الأسعار غير المواتية.",
	"VOLATILITYVOL": "التقلبات (VOL)",
	"VOLATILITYVOLText": "يتميز بتحركات سريعة وعشوائية في الأسعار، وهو مصطلح يستخدم للإشارة إلى الأسواق النشطة التي غالبا ما تقدم الفرص التجارية.",
	"VOLUME_s": "حجم",
	"VOLUMEText": "إجمالي عدد العقود المتداولة خلال فترة محددة.",
	"WeakDollarStrongDollar": "ضعف الدولار / الدولار القوي",
	"WeakDollarStrongDollarText": "يستخدم مصطلح الدولار الضعيف والقوي في سوق الصرف الأجنبي لوصف القيمة النسبية للدولار الأمريكي وقوته مقابل العملات الأخرى. ويقال إن الدولار يكون ضعيفا عندما يطلب المزيد من الدولارات لشراء وحدة واحدة من عملة أخرى وقوي عندما يطلب من بضعة دولارات لشراء وحدة واحدة من عملة أخرى.",
	"Whipsaw": "المنشار",
	"WhipsawText": "حالة من التقلبات الشديدة عندما يتبع النمو السريع للسعر انخفاض حاد (أو العكس بالعكس).",
	"Yard": "ساحة",
	"YardText": "مصطلح الفورك الفورك لمليار وحدة",
	"YIELD": "أدر",
	"YIELDText": "الدخل المكتسب من الاستثمار.",
	"steps_heading1": "معلومات شخصية",
	"steps_heading2": "إعلان",
	"steps_heading3": "تحميل المستندات الشخصية",
	"step1_personalinfo": "معلومات شخصية",
	"step1_fname": "الاسم الأول",
	"step1_age_error": "يجب أن يتراوح العمر بين 18 و80 عاما",
	"step1_lname": "اسم العائلة",
	"step1_dob": "تاريخ الولادة",
	"step1_dobrequired": "مطلوب DOB",
	"step1_below18": "عمرك أقل من 18 سنة",
	"step1_addinfo": "معلومات العنوان",
	"step1_city": "مدينة",
	"step1_postalcode": "الرمز البريدي",
	"step1_countryRes": "بلد الإقامة",
	"step1_otherinfo": "معلومات أخرى",
	"step1_addInfo": "معلومات إضافية",
	"step1_phno": "رقم الهاتف",
	"step1_phnoRequired": "رقم الهاتف مطلوب",
	"step1_correctno": "الرجاء إدخال رقم الهاتف الصحيح",
	"step1_prefcurrency": "حدد عملة المحفظة المفضلة",
	"step1_pep": "هل أنت شخص مكشوف سياسيا (PEP)؟",
	"step1_usPerson": "هل أنت شخص أمريكي؟",
	"step1_Next": "التالي",
	"step1_firstmember": "معلومات العضو الأول",
	"step1_member1dob": "مطلوب عضو 1 تاريخ الميلاد",
	"step1_member1age": "عضو 1 العمر هو خوار 18",
	"step1_secondmember": "معلومات العضو الثاني",
	"step1_menber2dobreq": "مطلوب عضو 2 تاريخ الميلاد",
	"step1_member2age": "عضو 2 العمر هو خوار 18",
	"step1_adressinfo": "معلومات العنوان",
	"step1_companyinfo": "معلومات الشركة",
	"step1_companyname": "اسم الشركة",
	"step1_incopDate": "تاريخ التأسيس ",
	"step1_incodateReq": "تاريخ التأسيس مطلوب",
	"step1_futuredate": "تاريخ المستقبل غير المسموح به",
	"step1_authorperson": "معلومات الشخص المعتمد",
	"step1_companyAdrsinfo": "معلومات عنوان الشركة",
	"step1_regAddone": "خط عنوان الشركة المسجل 1",
	"step1_regAddtwo": "خط عنوان الشركة المسجل 2",
	"step1_country": "بلد",
	"step1_minimumph": "يتضمن رقم الهاتف 8 أحرف على الأكثر",
	"step1_maxphone": "قد لا يزيد رقم الهاتف عن 15 حرفا",
	"step1_stepMsz2": "و PEP هو شخص طبيعي عهد إليه بالمهام العامة البارزة التالية في أي بلد، وكذلك أفراد أسرته المباشرين والأشخاص المعروفين بأنهم مقربون من هذا الشخص: <ul> <li>رؤساء الدول، رؤساء الحكومات، الوزراء ونواب الوزراء أو مساعديهم،</li> <li> أعضاء البرلمانات أو الهيئات التشريعية المماثلة، </li> <li>أعضاء مجالس إدارة الأحزاب السياسية،</li> <li>وأعضاء المحاكم العليا، والمحاكم الدستورية أو الهيئات القضائية الرفيعة المستوى الأخرى التي لا تخضع قراراتها لمزيد من الاستئناف، إلا في ظروف استثنائية،</li> <li>وأعضاء محاكم مراجعي الحسابات أو مجالس إدارة المصارف المركزية والسفراء</li> <li>والموظفين المسؤولين©وكبار الضباط في القوات المسلحة،</li> <li> أعضاء الهيئات الإدارية أو الإدارية أو الإشرافية في الشركات الحكومية أو المؤسسات المملوكة للدولة أو</li> <li>المديرين أو نواب المديرين وأعضاء مجلس الإدارة أو الأشخاص الذين يشغلون منصبا معادلا في منظمة دولية،</li> <li>رؤساء البلديات</li> </ul>",
	"step1_stepMsz3": "تعريف شخص الولايات المتحدة (â € € œUnited الدول personâ € ) ويشمل : <ul> <li> مواطن أمريكي أو مقيم (بما في ذلك الجنسية المزدوجة) ،</li> <li> أجنبي الولايات المتحدة (مقيم لأغراض ضريبية)</li> <li> شخص ولد في الولايات المتحدة؟ </li>   <li> شخص لديه عنوان بريد أو إقامة حالي في الولايات المتحدة (بما في ذلك صندوق بريد أمريكي أو أمريكي لرعاية العنوان) </li> <li> شخص يحمل رقم هاتف أمريكي حالي </li> <li> A شخص لديه تعليمات دائمة بتحويل الأموال إلى حساب يتم الاحتفاظ به في الولايات المتحدة؟</li>  <li> شخص لديه توكيل رسمي حالي وفعال أو سلطة موقعة ممنوحة لشخص يحمل عنوانا أمريكيا؟</li> </ul>",
	"step4_readaccept": "لقد قرأت وفهمت وقبلت",
	"step4_ClientAgreement": "اتفاقية العميل",
	"step4_privacyplicy": "سياسة الخصوصية",
	"step4_and": "و",
	"step4_riskDisclosr": "وثائق الإفصاح عن المخاطر",
	"step4_termsAgreeRqd": "يرجى الموافقة على هذه الشروط",
	"step4_policytwo": "أوافق على معالجة بياناتي الشخصية وتخزينها وفقا لسياسة الخصوصية، وعلى Fxview الاتصال بي بخصوص المعلومات الهامة لحسابي",
	"step4_AfterCalling": "ملاحظة: بعد النقر على",
	"step4_saveContinue": "حفظ ومتابعة",
	"step4_allInfoCorrect": "لن تتمكن من تغيير أي معلومات خطوة سابقة. تأكد من صحة جميع المعلومات!",
	"step5_browsersupport": "ربما يواجه المتصفح بعض المسألة التقنية مع كاميرا ويب",
	"step5_cameradenied": "رفض إذن الكاميرا",
	"step5_scanqrcode": "مسح رمز الاستجابة السريعة بدلا من ذلك",
	"step5_scanqrmobile": "مسح رمز الاستجابة السريعة هذا باستخدام كاميرا الجوال أو تطبيق رمز الاستجابة السريعة",
	"step5_keepageopen": "يرجى إبقاء هذه الصفحة مفتوحة أثناء استخدامك للهواتف المحمولة",
	"step5_continueBrowser": "متابعة مع المتصفح",
	"step5_docSubsuccess": "تم تقديم المستندات بنجاح. يرجى التحلي بالصبر أثناء مراجعة مستنداتك وقد يستغرق الأمر ما يصل إلى 24 ساعة أو أكثر خلال وقت الذروة.",
	"step5_reviewstatus": "انقر هنا لمراجعة حالة تذكرتك",
	"step5_identifyDoc": "وثائق الهوية",
	"step5_proofresidence": "وثائق إثبات الإقامة",
	"step5_uploadphototext": "قم بتحميل صورة لمستند الهوية الخاص بك. يرجى التأكد من تطابق التفاصيل الموجودة في هيئة الأحوال الشخصية مع المعلومات التي أدخلتها في نموذج المعلومات الشخصية.",
	"step5_uploadproof": "قم بتحميل إثبات عنوان إقامتك (باسمك ولا يزيد عمره عن 6 أشهر). يرجى ملاحظة أننا لا نقبل لقطات الشاشة.",
	"step5_takephoto": "التقاط صورة لرخصة القيادة الخاصة بك وتحميلها هنا",
	"step5_takegovernid": "التقاط صورة للحكومة أصدرت هوية وتحميلها هنا",
	"step5_goodQuality": "نوعية جيدة:",
	"step5_brightclear": "مشرق وواضح",
	"step5_note": "ملاحظه:",
	"step5_allcorner": "يجب أن تكون كافة زوايا المستند مرئية والمستند صالح (غير منتهي الصلاحية)",
	"step5_allcorner1": " يجب أن تظهر اسمك الكامل وعنوان الإقامة والمؤسسة المصدرة وتاريخ الإصدار. جميع أركان الوثيقة لتكون واضحة للعيان.",
	"step5_uploadfrontside": "الرجاء تحميل الجانب الأمامي من المستند",
	"step5_maximumfilesize": "يمكن تحميل الحد الأقصى لحجم الملفات حتى ",
	"step5_maxfilesize": "الحد الأقصى لحجم الملف المقبول يصل إلى ",
	"step5_uploadbackside": "تحميل الجزء الخلفي من المستند",
	"step5_upload": "رفع",
	"step5_idenfNumber": "يرجى ذكر رقم التعريف الخاص بك الموجود في docuemtn هويتك.",
	"step5_uploadpassport": "التقاط صورة لجواز سفرك وتحميلها هنا",
	"step5_photolicense": "التقاط صورة لرخصة القيادة الخاصة بك وتحميلها هنا",
	"step5_photogovernmentID": "التقاط صورة للحكومة أصدرت هوية وتحميلها هنا",
	"step5_proofsixold": "التقاط صورة لإثباتك أو إقامتك (لا يزيد عمرها عن 6 أشهر):",
	"step5_bankstatement": "كشف حساب مصرفي، فاتورة مرافق (مياه، كهرباء، إنترنت منزلي أو خط أرضي)، وثيقة ضريبية، اتفاقية إيجار (إذا تم إصدارها في آخر 6 أشهر)",
	"step5_uploadyourDoc": "تحميل المستند",
	"step5_idnorequired": "رقم معرف مطلوب.",
	"step5_filesizemax": "يمكن أن يكون حجم الملفات الحد الأقصى",
	"step5_filesallowed": "يسمح فقط jpg، jpeg، بابوا غينيا الجديدة، ملفات pdf! ",
	"step5_uploadbothside": "الرجاء تحميل كلا جانبي المستند",
	"step5_verifydoc": "يرجى تحميل المستند للتحقق من معلوماتك",
	"step5_continuemobile": "الاستمرار في استخدام الهاتف المحمول",
	"step5_recentphoto": "الرجاء تحميل صورتك الأخيرة",
	"step5_photoverif": "التحقق من الصورة",
	"step5_legitimacy": "يطلب من جميع المستخدمين تحميل صورة التحقق. هذا هو مجرد جزء من العديد من التقنيات والنظم التي نستخدمها لضمان شرعية مستخدمينا.",
	"step5_back": "الخلف",
	"step5_start": "استخدام كاميرا ويب",
	"step5_TakeSelfie": "التقاط صورة سيلفي",
	"step5_webcamdont": "الاستمرار مع الجوال",
	"step5_captureimage": "التقاط صورة",
	"step5_cancel": "إلغاء الأمر",
	"step5_filemax": "يمكن أن يكون حجم الملفات أقصى من",
	"step5_choosefileupload": "اختر ملف لتحميله",
	"step5_allowmaxsize": "الحد الأقصى لحجم الملف الذي نسمح به هو",
	"step5_useWebcam": "استخدام كاميرا ويب",
	"soclTrade_zullutrade": "ZuluTrade",
	"soclTrade_mql": "MQL5",
	"zulu_trade": "ZuluTrade",
	"zulu_zulitradeinfo": "Zulu Trade هي منصة تداول اجتماعية حيث يمكنك متابعة المتداولين في جميع أنحاء العالم ونسخ الصفقات أثناء التعلم من الاستراتيجيات التي يستخدمونها. بناء على المعلومات الكاملة المتاحة لأساليب التداول والأداء، يمكنك بسهولة جعل التجار من اختيارك وبمجرد متابعتها، سيتم نسخ صفقاتهم تلقائيا في حسابك.",
	"zulu_createAccount": "إنشاء حساب Zulu",
	"zulu_setupzulutrade": "كيفية إعداد حساب ZuluTrade",
	"zulu_registeropen": "سجل وافتح حساب Fxview ZuluTrade.",
	"zulu_findaccount": "قم بتمويل الحساب بحد أدنى 100 دولار أمريكي لتلقي بيانات اعتماد تسجيل الدخول من ZuluTrade.",
	"zulu_logintozulu": "تسجيل الدخول إلى موقع التجارة الزولو والبدء في اتباع أي تاجر (ق) من اختيارك.",
	"mampam_heading": "MAM/PAMM",
	"mampam_programenable": "برنامج FXVIEW MAM/PAMM يمكن المتداولين ذوي الخبرة من إدارة حسابات فرعية متعددة تحت حساب رئيسي واحد، بطريقة مهنية.",
	"mampam_knowmore": "اعرف المزيد",
	"mampam_becameinvestor": "كيف تصبح مستثمرا:",
	"mampam_clicktobecame": "انقر على أن تصبح مستثمرا",
	"mampam_uniquepamid": "أدخل managerâ € ™ ™ق معرف PAMM فريدة من نوعها لعرض ملفه الشخصي.",
	"mampam_createinverstor": "إنشاء حساب المستثمر الخاص بك والتواصل مع حساب PAMM",
	"mampam_monitoracc": "مراقبة حسابك من خلال PAMM investorâ € ™ ™ق لوحة القيادة",
	"mampam_connectmanager": "الاتصال بمدير",
	"mampam_becomemanager": "كيف تصبح مديرا:",
	"mampam_clickbecomemanager": "انقر على â € œbecome مدير €",
	"mampam_meetconditions": "تلبية الشروط المطلوبة لاستلام معرف PAMM الفريد",
	"mampam_manageaccount": "إدارة حسابك من خلال بوابة PAMM الحصرية",
	"mampam_becomeManager": "أصبح مديرا",
	"mql_heading": "MQL5",
	"mql_text": "MQL5 هي واحدة من أكبر مجتمعات تداول النسخ في العالم، وتربط التجار المبتدئين مع ذوي الخبرة. يمكن للمستخدمين الاختيار من بين آلاف الإشارات التي تم التحقق منها مجانا والمسؤولين عن الرسوم لتحسين أدائهم التجاري",
	"mql_createliveAcc": "إنشاء حساب حقيقي",
	"mql_stepsRegister": "خطوات تسجيل MQL5",
	"mql_stepone": "تسجيل حساب MQL5 على مواقعها الإلكترونية",
	"mql_stepTwo": "افتح منصة Metatrader واذهب إلى خيارات أدوات >> وانقر على علامة التبويب المجتمع. تسجيل الدخول إلى حساب MQL5 ثم انقر فوق موافق.",
	"mql_stepThree": "انتقل إلى علامة التبويب إشارات في نافذة المحطة الطرفية وحدد الإشارة التي تريد متابعتها.",
	"unaut_under": "تحت",
	"unaut_Verification": "التحقق",
	"unaut_pendingVerificationMsz1": "يخضع طلبك للمراجعة من قبل قسم الامتثال لدينا. قد يستغرق التحقق من مستنداتك من 3 إلى 4 أيام عمل. ستتلقى رسالة بريد إلكتروني بمجرد التحقق من مستنداتك",
	"createzullu_Your": "الخاص بك",
	"createzullu_successcreate": "تم إنشاء حساب zulu بنجاح. بيانات الاعتماد الخاصة بك هي:",
	"createzullu_accountBaseCurrency": "عملة الحساب الأساسية",
	"createzullu_tradenow": "التجارة الآن",
	"createzullu_forWeb": "للويب",
	"createzullu_open": "مفتوح",
	"createzullu_tradingAcc": "حساب التداول",
	"createzullu_classic": "كلاسيكي",
	"createzullu_USD": "دولار",
	"createzullu_EUR": "اليورو",
	"createzullu_GBP": "الجنيه الإسترليني",
	"createzullu_AUD": "الدولار الإستلاري",
	"createzullu_ZAR": "راند جنوب أفريقيا",
	"createzullu_leverageField": "الرافعة المالية حقل مطلوب",
	"createzullu_accountPassword": "كلمة مرور حساب التداول",
	"createzullu_passwordcontain": "يجب أن تحتوي كلمة المرور على 6 أحرف كحد أدنى و15 حرفا كحد أقصى، وتتضمن حرفا خاصا بحد أقصى (!@#$٪^*/)",
	"createzullu_createAccount": "إنشاء حساب",
	"demoacc_demomsg": "تم إنشاء حساب تجريبي بنجاح. بيانات الاعتماد الخاصة بك هي:",
	"demoacc_MT4": "ميتاتريدر 4",
	"demoacc_MT5": "ميتاتريدر 5",
	"demoacc_passwordMust": "يجب أن تحتوي كلمة المرور على 6 أحرف كحد أدنى و24 حرفا كحد أقصى، وتتضمن حرفا خاصا بحد أقصى (!@#$٪^*/) ",
	"liveacc_accounthas": "تم الحساب المباشر ",
	"liveacc_successfully": "نجاح",
	"liveacc_credentialsare": "انشاء. بيانات الاعتماد الخاصة بك هي:",
	"wit_Wallet_from_wallet": "من المحفظة",
	"depMsz11": "ليس حساب سكريل الصحيح؟ الرجاء",
	"wit_Wallet_Back": "العودة إلى المحفظة",
	"wit_Wallet_No": "لا توجد محفظة",
	"wit_withdrawal": "السحب",
	"wit_freeMargin": "هامش حر",
	"wit_withdrawalMsz1": "عذرا، أنت غير مؤهل للانسحاب بعد. الإيداع والتداول يمكن أن تساعدك على أن تصبح مؤهلا!",
	"wit_PrincipalWithAmount": "مبلغ السحب الرئيسي",
	"wit_AccNumber": "رقم الحساب:",
	"wit_skrillId": "معرف سكريل:",
	"wit_netId": "معرف نيتيلر:",
	"wit_creditCardNumber": "رقم بطاقة الائتمان",
	"wit_expiryDate": "تاريخ انتهاء الصلاحية",
	"wit_allowOption": "الرجاء الاختيار من بين الخيارات المسموح بها أعلاه",
	"wit_WithdrawalMethodReq": "طريقة السحب مطلوبة",
	"wit_EnterWithdrawal": "أدخل السحب",
	"wit_requestWithdrawal": "يمكنك طلب السحب من خيارات الدفع المعتمدة حديثا بعد 24 ساعة من الموافقة",
	"wit_withdrawalMsz2": "لقد تلقينا طلب السحب الخاص بك، وسوف نقوم بتحديث لكم وفقا لذلك",
	"wit_withCont1": "لا تفرض Fxview رسوم سحب. ومع ذلك، لاحظ بسهولة أن معالجي الدفع / الوسطاء الماليين قد يفرضون رسوم معاملة.",
	"wit_withCont2": "نظرا للقيود المفروضة على معاملات الطرف الثالث، لا يمكن إرجاع الأموال إلا إلى حساب مصرفي بنفس اسم حساب تداول Fxview الخاص بك. وعلاوة على ذلك، لن تعاد الأموال إلا إلى نفس الحساب المصرفي الذي استلمت منه.",
	"wit_withCont3": "لا يمكن أن يتجاوز المبلغ الإجمالي الذي يمكنك سحبه إلى بطاقتك المبلغ الإجمالي المودع في البطاقة. يمكن سحب المبالغ التي تتجاوز هذا المستوى إلى حسابك المصرفي، نيتيلر أو سكريل",
	"withdraw_backWithdraw": "العودة إلى الانسحاب",
	"withdrawList": "قائمة الانسحاب",
	"withdrawList_all": "كل",
	"withdrawList_pending": "المعلقه",
	"withdrawList_processed": "معالجه",
	"withdrawList_rejected": "رفضت",
	"withdrawList_created": "تاريخ",
	"withdrawList_accountId": "رقم حساب/محفظة",
	"withdrawList_amount": "مبلغ",
	"withdrawList_currency": "عملة",
	"withdrawList_withdrawalType": "نوع السحب",
	"withdrawList_method": "طريقة",
	"withdrawList_withdrawalStatus": "حالة",
	"withdrawList_detail": "تفصيل",
	"withdrawList_viewTicket": "عرض التذكرة",
	"Wallet_Wallet": "محفظة",
	"Wallet_Loyalty_Points": "نقاط الولاء",
	"Wal_detail_Add_New": "إضافة عملة محفظة جديدة",
	"Wal_detail_Wallet_ID": "معرف المحفظة",
	"Wal_detail_Deposit": "أودع",
	"Wal_detail_Withdraw": "سحب",
	"Wal_detail_Transfer": "نقل",
	"Wal_detail_curr_required": "حقل العملة مطلوب",
	"Wal_detail_Submit": "إرسال",
	"Wal_detail_Trans_History": "سجل الحركة",
	"Wal_detail_Date": "تاريخ",
	"Wal_detail_Time": "الوقت",
	"Wal_detail_Type": "نوع",
	"Wal_detail_From": "من",
	"Wal_detail_To": "ل",
	"Wal_detail_Amount": "مبلغ",
	"Wal_detail_Status": "حالة",
	"Wal_detail_availAmount": "المبلغ المتاح:",
	"acc_fund_Deposit": "أودع",
	"acc_fund_Withdrawal": "انسحاب",
	"chang_wal_curr_Internal_Transf": "تحويل داخلي للمحفظة",
	"chang_wal_curr_Transf_Wall_amount": "مبلغ محفظة التحويل",
	"chang_wal_curr_Back": "العودة إلى المحفظة",
	"loyalP_Reward_Points": "نقاط مكافأة الولاء",
	"loyalP_Know_More": "اعرف المزيد",
	"loyalP_Trans_Wallet": "التحويل إلى المحفظة",
	"loyalP_Transfer": "نقل",
	"loyalP_transf_TotalP": "مجموع نقاط الولاء",
	"loyalP_transf_Amou_Avail": "المبلغ المتاح",
	"loyalP_transf_Enter_p_transfe": "أدخل نقطة للتحويل",
	"loyalP_transf_Cancel": "إلغاء الأمر",
	"loyalP_transf_Transfer": "نقل",
	"loyalP_transf_Back": "العودة إلى المحفظة",
	"loyalP_transToAcc": "التحويل إلى معرف المحفظة",
	"loyalP_fieldReq": "الحقل مطلوب",
	"loyalP_intTransMsz2": "الرجاء الضغط على الرابط لتأكيد نقلك الداخلي",
	"loyalP_intTransMsz3": "تم إتمام عملية النقل بنجاح",
	"loyalP_fromTradId": "من معرف التداول",
	"loyalP_toTradId": "إلى معرف التداول",
	"loyalP_transferAmount": "المبلغ المحول",
	"loyal_card_det_You_are_a": "أنت",
	"loyal_card_det_member": "عضو",
	"loyal_card_det_Points": "النقاط",
	"loyal_card_det_Last_Credit_On": "آخر ائتمان على",
	"loyal_card_det_Earn": "كسب",
	"loyal_card_det_more_points_to_jump_to": "المزيد من النقاط للقفز إلى",
	"loyal_card_det_gain_add_benefi": "للحصول على فوائد إضافية",
	"loyal_List_Trans_History": "سجل الحركة",
	"loyal_List_Date": "تاريخ",
	"loyal_List_Activity": "نشاط",
	"loyal_List_Volume": "حجم",
	"loyal_List_Points": "النقاط",
	"loyal_List_Cr_Db": "Cr/Db",
	"loyal_ver_back": "العودة إلى المحفظة",
	"redeamP_your_points": "استرداد نقاط الولاء الخاصة بك",
	"redeamP_Points": "النقاط",
	"redeamP_Redeem": "إسترداد",
	"redeamP_Red_Points": "استرداد النقاط",
	"redeamP_Now": "استرد الان",
	"redeamP_walletpoints": "يرجى استرداد نقاط المحفظة وفقا لنقاط التفاصيل التالية <br> : ",
	"redeamP_pointdesc": "<br> point_desc :",
	"tool_overview": "نظره عامه",
	"tool_autochartistScan": "ماسح ضوئي للشاري التلقائي",
	"tool_autochartistWeb": "ويب الشاري التلقائي",
	"tool_Vpsheading": "VPS",
	"tool_ecoCalendar": "التقويم الاقتصادي",
	"tool_tradingToolbox": "صندوق أدوات المتداول",
	"tool_Calculator": "ألات حاسبة",
	"tool_tradingHOur": "ساعات التداول",
	"tool_Signal": "اشارات",
	"autoScan_knoMore": "اعرف المزيد",
	"autoScan_DownLive": "تحميل لحساب حقيقي",
	"autoScan_HowInstall": "كيفية تثبيت التخطيط التلقائي",
	"autoScan_usrGuide": "دليل المستخدم",
	"autoScan_goTool": "في المنصة، انتقل إلى أدوات > الخيارات > المستشارين الخبراء للسماح باستيراد DLL والنقر على موافق.",
	"toolVps_sureImp": "هل أنت متأكد من تنفيذ هذه العملية؟",
	"toolVps_confirm": "أكد",
	"toolVps_cancel": "إلغاء الأمر",
	"toolVps_Shut_Down": "إيقاف التشغيل",
	"toolVps_Restart": "اعاده تشغيل",
	"toolVps_Reboot": "اعاده تمهيد",
	"toolVps_Change_Pass": "تغيير كلمة المرور",
	"toolVps_VieDet": "عرض التفاصيل",
	"toolVps_UpdAcc": "تحديث الحساب",
	"toolVps_Unsubscribe": "إلغاء الاشتراك",
	"toolVps_vpsList": "قائمة <span>الخادم</span> الخاص الظاهري (VPS)",
	"toolVps_createVps": "إنشاء VPS",
	"toolVps_SubList": "قائمة الاشتراكات",
	"toolVps_accWalt": "الحساب/المحفظة",
	"toolVps_Priodicity": "دورية",
	"toolVps_Price": "ثمن",
	"toolVps_strtDate": "تاريخ البدء",
	"toolVps_endDate": "تاريخ الانتهاء",
	"toolVps_Action": "فعل",
	"toolVps_vps": "<span>خادم</span> خاص ظاهري (VPS)",
	"toolVps_vpsTilte": "استمتع بتجربة تداول لا مثيل لها معنا، حيث يتم ضمان استقرار صفقاتك. لا داعي للقلق بشأن الكمون أو التعامل مع برامج متعددة على النظام الخاص بك بعد الآن. استخدم VPS المجانية للحصول على استجابات سريعة لصفقاتك والاستمتاع بسرعات رائعة على منصاتنا.",
	"toolVps_redLate": "زمن وصول مخفض",
	"toolVps_freeOn5000": "مجانا بإيداع 5000 دولار أو أكثر",
	"toolVps_remoteAcccess": "الوصول عن بعد",
	"toolVpsstab_Env": "بيئة مستقرة",
	"toolVps_back_vpsList": "العودة إلى قائمة VPS",
	"toolVps_tc": "تطبق الشروط والأحكام",
	"toolVps_Plan": "خطة",
	"toolVps_Status": "حالة",
	"toolVps_type": "نوع",
	"toolVps_nextpayment": "الدفعة التالية",
	"toolVps_passWordMustContain12": "يجب أن تحتوي كلمة المرور على 12 حرفا على الأقل، وأن تتضمن رقما ورقما كبيرا واحد وحرفا خاصا (!@#$٪^&/)",
	"toolVps_verifySubscribe": "تمت معالجة طلب حساب التداول التحديث بنجاح",
	"toolVps_back_subList": "العودة إلى قائمة الاشتراك",
	"toolVps_reqProcessing": "معالجة الطلب...",
	"toolVps_reqVerify": "طلب التحقق",
	"toolVps_reqFailed": "فشل الطلب",
	"VpsSub_1_Record": "لديك سجل واحد فقط يرجى إنشاء حساب تداول واحد على الأقل أو محفظة أخرى قبل محاولة تغيير حساب الاشتراك.",
	"VpsSub_liveAcc": "حساب مباشر",
	"VpsSub_Wallet": "محفظة",
	"VpsSub_ChangeTradAcc": "تغيير حساب تداول الاشتراك",
	"VpsSub_back_subLis": "العودة إلى قائمة الاشتراك",
	"VpsSub_Submit": "إرسال",
	"VpsSub_received_request": "لقد تلقينا طلب تغيير حساب التداول الخاص بك، وسوف نقوم بتحديث لكم وفقا لذلك",
	"VpsSub_withdrawalAuthMessage": "يرجى التحقق من طلب السحب بالنقر على الرابط الذي أرسلناه إلى معرف بريدك الإلكتروني المسجل",
	"VpsSub_noTradingAccFound": "لا يوجد حساب تداول مباشر!",
	"VpsUnSub_1_record": "لديك سجل واحد فقط يرجى إنشاء حساب تداول واحد على الأقل أو محفظة أخرى قبل محاولة تغيير حساب الاشتراك.",
	"VpsUnSub_liveAcc": "حساب مباشر",
	"VpsUnSub_Wallet": "محفظة",
	"VpsUnSub_sureUnsub": "هل أنت متأكد من إلغاء الاشتراك",
	"VpsUnSub_plan_": "خطة؟",
	"VpsUnSub_confirm": "أكد",
	"VpsUnSub_Cancel": "إلغاء الأمر",
	"VpsUnSub_received_request": "لقد تلقينا طلب تغيير حساب التداول الخاص بك، وسوف نقوم بتحديث لكم وفقا لذلك",
	"VpsUnSub_back_subList": "العودة إلى قائمة الاشتراك",
	"VpsUnSubVer_successfully": "تمت معالجة طلب خطة إلغاء الاشتراك بنجاح",
	"VpsUnSubVer_back_subList": "العودة إلى قائمة الاشتراك",
	"marktTrdHour_title": "ساعات التداول في السوق",
	"marktTrdHour_txt": "وقت الخادم الخاص بنا هو GMT+3 أثناء التوقيت الصيفي الأمريكي (DST) و GMT+2 أثناء التوقيت الصيفي غير الأمريكي (غير التوقيت الصيفي).",
	"marktTrdHour_table_below": "يسرد الجدول أدناه ساعات الافتتاح والإغلاق لمختلف الأدوات وفئات الأصول وفقا لوقت الخادم.",
	"marktTrdHour_Forex": "الفوركس",
	"marktTrdHour_Indices": "مؤشرات",
	"marktTrdHour_Commodities": "السلع الاساسيه",
	"marktTrdHour_Open": "مفتوح",
	"marktTrdHour_Close": "غلق",
	"marktTrdHour_Break": "إستراحة",
	"trdMarktPlac_title": "<span>سوق</span> التاجر",
	"trdMarktPlac_txt": "تصفح سوقنا للوصول إلى الاستراتيجيات التي أنشأها بعض من أفضل المتداولين في العالم، أو تصميم السوق الخاصة بك، وسوف نساعدك على الحصول عليه بنيت.  سوقنا هو محطة واحدة لنقل التداول الخاص بك إلى المستوى التالي.",
	"trdMarktPlac_Automate": "أتمتة <span>التداول</span> الخاص بك للحصول على أقصى استفادة من الأسواق",
	"trdMarktPlac_Customise": "تخصيص التداول الخاص بك",
	"trdMarktPlac_Customise_Txt": "تحديد الاحتياجات الخاصة بك وجلب النظام الخاص بك إلى الحياة من خلال الاتصال مع المطور الذي سيتم بناء عليه بالنسبة لك",
	"trdMarktPlac_Risk_manag": "إدارة المخاطر",
	"trdMarktPlac_Risk_manag_txt": "مراجعة أداء مزودي الإشارات بناء على خبرتهم وأفضل وأسوأ الصفقات وملف تعريف المخاطر وأكثر من ذلك",
	"trdMarktPlac_Browse_library": "تصفح مكتبتنا",
	"trdMarktPlac_Browse_libraryTxt": "تصفح مكتبتنا الواسعة من EAs والمؤشرات لMT4 و MT5 و ActTrader، وابحث عن الملاءمة المناسبة لاحتياجاتك",
	"trdMarktPlac_Categories": "فئات",
	"trdMarktPlac_All": "كل",
	"trdMarktPlac_Expert": "خبير",
	"trdMarktPlac_Advisors": "المستشارين",
	"trdMarktPlac_Indicators": "المؤشرات",
	"trdMarktPlac_ActTrader": "ActTrader",
	"trdMarktPlac_Popular": "شعبي",
	"trdMarktPlac_New": "الجديد",
	"trdMarktPlac_Free": "مجاني",
	"trdMarktPlac_Paid": "مدفوع",
	"trdMarktPlac_Long_Str": "استراتيجيات طويلة الأجل",
	"trdMarktPlac_2frame": "إطاران",
	"trdMarktPlac_StratCon2": "تتكون الاستراتيجية من تاريخين مختلفين للمخططات:",
	"trdMarktPlac_Details": "التفاصيل",
	"trdMarktPlac_Add_List": "إضافة إلى قائمة",
	"trdMarktPlac_Hammer_Ass": "مساعد المطرقة",
	"trdMarktPlac_Strat_trad_assis": "هذه الاستراتيجية (مساعد التداول) سوف يحذرك عندما مطرقة تتشكل و",
	"trdMarktPlac_Pos_Mgmt": "إدارة الوظائف",
	"trdMarktPlac_Lot_Cal": "حاسبة اللوت",
	"trdMarktPlac_Lot_Cal_txt": "الات حساب اللوت - هي أداة فوركس التي تمكنك من حساب حجم ال...",
	"trdMarktPlac_Short_Strat": "استراتيجيات قصيرة الأجل",
	"trdMarktPlac_Reg_Stra": "إستراتيجية الانحدار",
	"trdMarktPlac_Reg_StraTxt": "استراتيجية يفتح موقف شراء عندما تكون القيمة المنخفضة للشمعة الحالية = حزام أعلى ..",
	"trdMarktPlac_NoData": "لا توجد بيانات",
	"ecoCalendar": "التقويم الاقتصادي",
	"ecoCal_Title_Txt": "تتبع الأحداث الاقتصادية الهامة والإصدارات التي تؤثر على الفوركات والسلع والمؤشرات.",
	"ecoCal_Up_next": "لأعلى بعد ذلك",
	"ecoCal_Country": "بلد",
	"ecoCal_Select_All": "حدد الكل",
	"ecoCal_Clear": "واضح",
	"ecoCal_My_Filter": "عامل التصفية الخاص بي",
	"ecoCal_Default": "افتراضي",
	"ecoCal_Impact": "تأثير",
	"ecoCal_All": "كل",
	"ecoCal_Medium": "متوسط",
	"ecoCal_High": "عالي",
	"ecoCal_Save_filter": "حفظ الإعداد في عامل التصفية",
	"ecoCal_Apply_Filter": "تطبيق عامل التصفية",
	"ecoCal_Time": "الوقت",
	"ecoCal_TimeZ_Settings": "إعدادات المنطقة الزمنية",
	"ecoCal_TimeZ": "المنطقة الزمنية",
	"ecoCal_Select_TimeZ": "تحديد المنطقة الزمنية",
	"ecoCal_TimeF": "تنسيق الوقت",
	"ecoCal_Set_timeZ_Auto": "تعيين المنطقة الزمنية تلقائيا",
	"ecoCal_Save_Sett": "حفظ الإعداد",
	"ecoCal_Cancel": "إلغاء الأمر",
	"ecoCal_noRecord": "لا يوجد سجل",
	"ecoCal_Event": "حدث",
	"ecoCal_Actual": "حقيقي",
	"ecoCal_Forecast": "تنبؤ",
	"ecoCal_Previous": "سابق",
	"tools_Trad_Tools": "أدوات التداول",
	"tools_Trad_Tools_Txt": "اتخاذ قرارات استثمارية مستنيرة وفي الوقت المناسب باستخدام أدوات التداول القوية التي تساعدك على تحديد الفرص المحتملة وبناء استراتيجية تداول أقوى",
	"tools_Auto_Scanner": "ماسح ضوئي للشاري التلقائي",
	"tools_Auto_Scanner_txt": "لا تفوت فرصة التداول مرة أخرى..",
	"tools_VPS": "VPS",
	"tools_VPS_txt": "استمتع VPS الأساسية المجانية أو اختر من الاشتراك..",
	"tools_Eco_Calendar": "التقويم الاقتصادي",
	"tools_Eco_Calendar_txt": "البقاء على اطلاع على الأحداث الاقتصادية الهامة..",
	"tools_Trad_Toolbox": "صندوق أدوات التاجر",
	"tools_Trad_Toolbox_txt": "مجموعة متميزة من أدوات التداول والتحليل.",
	"tools_Calculators": "الالات الحاسبه",
	"tools_Calculators_txt": "حساب قيمة النقطة والهامش والمقايضات وأكثر من ذلك.",
	"tools_TradeMarket": "سوق التاجر",
	"tools_TradeMarket_txt": "العثور على EA المثالي الخاص بك أو مؤشر، أو لديك..",
	"tools_Trad_Hours": "ساعات التداول",
	"tools_Trad_Hours_txt": "نرى بسرعة عندما تكون الأسواق مفتوحة..",
	"tools_Auto_Idea": "فكرة التخطيط التلقائي",
	"tools_Auto_Idea_txt": "لا تفوت فرصة التداول مرة أخرى..",
	"tools_readmore": "اقرأ المزيد",
	"tools_downloa": "تحميل ل",
	"MT4Demo": "MT4 تجريبي",
	"MT5Demo": "MT5 تجريبي",
	"toolor": "أو",
	"toolknowMore": "اعرف المزيد",
	"chEn_entity": "كيان",
	"chEn_global": "Fxview العالمية",
	"chEn_europe": "Fxview أوروبا",
	"chEn_redirectmsg1": "بناء على اختيار بلد إقامتك، سيتم إعادة توجيهك إلى موقع Charlgate Ltd. المسجل في قبرص. تقع شركة Charlgate Ltd. ضمن الإطار التنظيمي الأوروبي، وهي ضمن نطاق التوجيه الثاني للأسواق في الأدوات المالية (MiFID II)، من بين أمور أخرى. وبالإضافة إلى ذلك، هناك اعتمادات تتعلق بخطة لتعويض المستثمرين.",
	"chEn_redirectmsg2": "",
	"chEn_continue": "استمر",
	"chEn_takeback": "خذني إلى الخلف",
	"adchart_create": "إنشاء",
	"adchart_save": "حفظ",
	"adchart_chart": "جدول",
	"adchart_Studies": "الدراسات",
	"adchart_failedchart": "فشل تحميل الشارت",
	"adchart_kindlyrefresh": "يرجى تحديث",
	"chart_loadchartfail": "فشل تحميل الشارت يرجى التحديث!",
	"filter_Selecttimezone": "حدد المنطقة الزمنية",
	"filter_Low": "منخفض",
	"filter_medium": "متوسط",
	"filter_high": "عالي",
	"filter_submit": "إرسال",
	"head_Wallet": "محفظة",
	"head_loyality": "نقاط الولاء",
	"head_createLiveAcc": "إنشاء حساب مباشر",
	"head_createDemoAcc": "إنشاء حساب تجريبي",
	"head_Notification": "اخطار",
	"head_seeAll": "شاهد الكل",
	"head_noNewNotification": "لا توجد إشعارات جديدة",
	"head_verified": "التحقق",
	"head_deposit_enabled": "تم تمكين الإيداع",
	"head_notVerified": "لم يتم التحقق",
	"head_profile": "ملف تعريف",
	"head_changePassword": "تغيير كلمة المرور",
	"successMsz4": "تم تغيير كلمة المرور بنجاح",
	"head_security": "أمن",
	"head_referFriend": "إحالة صديق",
	"head_logout": "تسجيل الخروج",
	"leftnav_dashboard": "لوحه القياده",
	"leftnav_wallet": "محفظة",
	"leftnav_accfunding": "تمويل الحساب",
	"leftnav_manageAcc": "إدارة الحساب",
	"leftnav_Depositbonus": "مكافأة الإيداع",
	"leftnav_socialTrade": "التداول الاجتماعي",
	"leftnav_tools": "ادوات",
	"leftnav_education": "التعليم",
	"leftnav_resources": "موارد",
	"leftnav_downloadplatform": "تحميل منصة",
	"leftnav_support": "دعم",
	"load_norecordfound": "لم يتم العثور على سجلات",
	"tradAcc_application": "يرجى إكمال طلب الحساب وإنشاء",
	"tradAcc_application1": "يرجى إكمال طلب الحساب الخاص بك إلى acccess هذه الوظيفة",
	"tradAcc_trading": "التجاره",
	"tradAcc_live": "حقيقي",
	"tradAcc_accountAccess": "الحساب للوصول إلى هذه الوظيفة.",
	"tradAcc_resumeApplication": "استئناف التطبيق",
	"tradAcc_checkappStatus": "طلبك قيد المراجعة، يرجى التحقق من حالة تذكرتك.",
	"tradAcc_ticket": "تذكرة",
	"tradAcc_createliveAcc": "الرجاء إنشاء حساب مباشر للوصول إلى هذه الوظيفة",
	"tradAcc_liveDemoAcc": "الرجاء إنشاء حساب مباشر أو تجريبي للوصول إلى هذه الوظيفة",
	"tradAcc_demoAcc": "الحساب التجريبي",
	"tradAcc_createWallet": "الرجاء إنشاء محفظة للوصول إلى هذه الوظيفة",
	"tradAcc_wallet": "محفظة",
	"pagin_totalRecords": "إجمالي السجلات",
	"acclist_fund": "إيداع",
	"acclist_addFund": "إضافة أموال",
	"acclist_addFundTo": "إضافة أموال إلى",
	"acclist_tradingId": "معرف التداول",
	"acclist_addingFundTo": "إضافة أموال إلى",
	"acclist_tradingAcc": "",
	"acclist_fund_msz": "الإيداع ناجح ",
	"acclist_fund_mszErr": "الإيداع غير ناجح",
	"acclist_changeLeverage": "تغيير الرافعة المالية",
	"acclist_changePassword": "تغيير كلمة المرور",
	"acclist_internalTransfer": "النقل الداخلي",
	"acclist_tradeNow": "التداول الأن",
	"acclist_detachAcc": "فصل الحساب",
	"accId_TransFromAccId": "التحويل من معرف الحساب",
	"accId_selectAccountId": "تحديد معرف الحساب",
	"accId_fieldReq": "الحقل مطلوب",
	"closetrad_login": "تسجيل الدخول",
	"closetrad_order": "أمر معلق",
	"closetrad_symbol": "رمز",
	"closetrad_volume": "حجم",
	"closetrad_openPrice": "سعر مفتوح",
	"closetrad_openTime": "وقت مفتوح",
	"closetrad_commision": "مهمة",
	"closetrad_type": "نوع",
	"closetrad_SL": "وقف",
	"closetrad_TP": "حد",
	"closetrad_closePrice": "سعر الإغلاق",
	"closetrad_closeTime": "إغلاق الوقت",
	"closetrad_Swap": "عمولة التبييت",
	"closetrad_PNL": "ربح أو خسارة",
	"closetrad_comment": "التعليق",
	"closetrad_price": "سعر",
	"OCtradelist_balance": "رصيد",
	"OCtradelist_margin": "هامش",
	"OCtradelist_equity": "رصيد إجمالي",
	"OCtradelist_pnl": "ربح أو خسارة",
	"OCtradelist_tradeNow": "التجارة الآن",
	"OCtradelist_opentrade": "فتح صفقة",
	"OCtradelist_closetrade": "إغلاق صفقة",
	"openOrder_orderId": "معرف الطلب",
	"openOrder_accountId": "معرف الحساب",
	"openOrder_quantity": "كمية",
	"openOrder_triggered": "تشغيل",
	"openOrder_side": "جنب",
	"openOrder_tradeId": "معرف التجارة",
	"openOrder_profit": "ربح",
	"openOrder_agentComm": "عمولة العميل ",
	"openOrder_cmd": "Cmd",
	"openOrder_sl": "وقف",
	"openOrder_tp": "حد",
	"openOrder_swaps": "عمولة التبييت",
	"trade_cal_title": "حاسبات التداول",
	"trade_cal_title_Txt": "توفر لك الآلات الحاسبة عبر الإنترنت طريقة سهلة لتحليل الصفقات التي تخطط للقيام بها. نساعدك على حساب القيم بناء على ظروف السوق وتزويدك بنتائج فورية.",
	"trade_cal_Commission": "عمولة",
	"trade_cal_Multi_Target": "متعدد الأهداف",
	"trade_cal_Pivot_Points": "النقاط المحورية",
	"trade_cal_Profit_Loss": "الربح والخسارة",
	"trade_cal_Fibonacci": "Fibonacci",
	"trade_cal_Pip_Value": "قيمة النقطة",
	"trade_cal_Swap": "عمولة التبييت",
	"trade_cal_Position_Size": "حجم الصفقة",
	"trade_cal_Currency_Convertor": "محول العملات",
	"cal_comm_title": "عمولة",
	"cal_comm_title_txt": "احسب العمولات التي ستدفعها مقابل صفقة مع حاسبة العمولة الخاصة بنا. Fxview رسوم عمولة قدرها 1/100،000 دولار في كل اتجاه (أو 2/100،000 دولار ذهابا وإيابا). سوف تساعدك حاسبة العمولة لدينا في حساب مقدار ما يعمل به هذا ، لأي تجارة معينة. ما عليك سوى إدخال فئة الأصول والرمز والعملة الأساسية للحساب وحجم التداول، واضغط على \"حساب الآن\".",
	"cal_comm_forex": "الفوركس",
	"cal_comm_commodities": "السلع الاساسيه",
	"cal_comm_indices": "مؤشرات",
	"cal_comm_Asset_Class": "فئة الأصول",
	"cal_comm_Field_req": "الحقل مطلوب",
	"cal_comm_USD": "دولار",
	"cal_comm_GBP": "الجنيه الإسترليني",
	"cal_comm_AUD": "دولار إسترالي",
	"cal_comm_EUR": "اليورو",
	"cal_comm_accBaseCurr": "عملة الحساب الأساسية",
	"cal_comm_Symbol": "رمز",
	"cal_comm_trade_size_lot": "حجم التجارة (بالقرعة)",
	"cal_comm_now": "حساب الآن",
	"cal_comm_Comm_roundT": "العمولة (ذهابا وإيابا)",
	"cal_marg_title": "هامش",
	"cal_marg_title_txt": "تساعدك حاسبة الهامش في تحديد الهامش المطلوب لفتح مركز. ما عليك سوى اختيار فئة الأصول والرمز والعملة الحساب وحجم التداول للتأكد من الهامش المطلوب اعتمادا على الحد الأقصى للرافعة المالية المقدمة لأنواع مختلفة من الأدوات.",
	"cal_marg_Field_req": "الحقل مطلوب",
	"cal_marg_accBaseCurr": "عملة الحساب الأساسية",
	"cal_marg_Symbol": "رمز",
	"cal_marg_trade_size_lot": "حجم التجارة (بالقرعة)",
	"cal_marg_now": "حساب الآن",
	"cal_marg_req": "طلب الهامش",
	"cal_marg_max_lev": "الحد الأقصى للرافعة المالية",
	"cal_marg_forex": "الفوركس",
	"cal_marg_commodities": "السلع الاساسيه",
	"cal_marg_indices": "مؤشرات",
	"cal_milti_Target": "هدف متعدد",
	"cal_milti_Target_txt": "تساعد هذه الآلة الحاسبة المتداولين على تخطيط أي جزء من مراكزهم يجب إغلاقه عند مستويات مستهدفة معينة للحصول على أفضل عائد ممكن لنسبة المخاطرة.",
	"cal_milti_Field_req": "الحقل مطلوب",
	"cal_milti_accBaseCurr": "عملة الحساب الأساسية",
	"cal_milti_Symbol": "رمز",
	"cal_milti_Position_Type": "نوع الموضع",
	"cal_milti_Buy": "شراء",
	"cal_milti_Sell": "بيع",
	"cal_milti_Open_Price": "سعر الفتح",
	"cal_milti_Stop_loss_Price": "سعر الوقف",
	"cal_milti_trade_size_lot": "حجم الصفقة (باللوت)",
	"cal_milti_Target_Price": "السعر المستهدف",
	"cal_milti_lots_Clos_Target": "اللوت أعلق عند الهدف",
	"cal_milti_Net_Lot_size": "صافي حجم اللوت:",
	"cal_milti_Now": "حساب الآن",
	"cal_milti_Target_Profit": "الربح المستهدف",
	"cal_milti_Total_Profit": "إجمالي الربح",
	"cal_milti_Return_Risk": "العودة إلى المخاطر",
	"cal_pivot_point_txt": "تقدم Fxview آلة حاسبة النقاط المحورية لمساعدتك في تحديد اتجاه الاتجاهات السائدة وتحديد مستويات الدعم والمقاومة.",
	"cal_pivot_High": "عال",
	"cal_pivot_Low": "منخفض",
	"cal_pivot_Open": "مفتوح",
	"cal_pivot_Close": "غلق",
	"cal_pivot_Calculate_Now": "حساب الآن",
	"cal_pivot_Clear": "واضح",
	"cal_pivot_CLASSIC": "كلاسيكي",
	"cal_pivot_WOODIE": "WOODIE'S",
	"cal_pivot_CAMARILLA": "CAMARILLA",
	"cal_pivot_DMARKS": "DMARKS'S",
	"cal_pivot_Resistance": "المقاومه",
	"cal_pivot_Pivot_Points": "النقاط المحورية",
	"cal_pivot_Support": "دعم",
	"cal_pivot_Field_req": "الحقل مطلوب",
	"cal_pivot_PivotPoints": "النقاط المحورية",
	"cal_profit_Loss": "الربح والخسارة",
	"cal_profitL_Txt": "Fxviewâ € ق ™الربح والخسارة آلة حاسبة هي أداة أساسية يمكن أن تساعدك على حساب الربح أو الخسارة من التجارة. ما عليك سوى تحديد فئة الأصول والرمز والعملة الأساسية للحساب وأسعار الفتح والإغلاق المطلوبة ونوع المركز وحجم التداول بالقرعة، واضغط على \"حساب الآن\".",
	"cal_profitLField_req": "الحقل مطلوب",
	"cal_profitL_accBaseCurr": "عملة الحساب الأساسية",
	"cal_profitL_Symbol": "رمز",
	"cal_profitL_Pos_Type": "نوع الموضع",
	"cal_profitL_Buy": "شراء",
	"cal_profitL_Sell": "بيع",
	"cal_profitL_Open_Price": "سعر الفتح",
	"cal_profitL_Close_Price": "سعر الإغلاق",
	"cal_profitL_trade_size_lot": "حجم الصفقة (باللوت)",
	"cal_profitL_Now": "حساب الآن",
	"cal_Fibonacci": "Fibonacci",
	"cal_fibo_txt": "مع fxviewâ € ق ™fibonacci آلة حاسبة ، يمكنك حساب الارتدادات فيبوناتشي على أساس النقاط المتطرفة من الرسم البياني في الاتجاه الصعودي أو الاتجاه الهابط. مجرد وضع القيم العالية والمنخفضة للبدء.",
	"cal_fibo_Uptrend": "الاتجاه الصعودي",
	"cal_fibo_Downtrend": "اتجاه هبوطي",
	"cal_fibo_Field_req": "الحقل مطلوب",
	"cal_fibo_High": "عال",
	"cal_fibo_Low": "منخفض",
	"cal_fibo_Now": "حساب الآن",
	"cal_fibo_Retracements": "الارتدادات",
	"cal_fibo_Support": "دعم",
	"cal_Pip_Value": "قيمة النقطة",
	"cal_Pip_txt": "أداة فعالة لإدارة استراتيجية المخاطر الخاصة بك، لدينا نقطة قيمة آلة حاسبة تمكنك من حساب القيمة لكل نقطة من كل موقف. مع هذه الأداة يمكنك مراقبة المخاطر الخاصة بك لكل تجارة بمزيد من الدقة.",
	"cal_Pip_Field_req": "الحقل مطلوب",
	"cal_Pip_accBaseCurr": "عملة الحساب الأساسية",
	"cal_Pip_Symbol": "رمز",
	"cal_Pip_trade_size_lot": "حجم الصفقة (باللوت)",
	"cal_Pip_Now": "حساب الآن",
	"cal_swap": "عمولة التبييت",
	"cal_swap_txt": "يمكن اعتبار المقايضات كتكلفة تمويل للحفاظ على مركز مفتوح. يمكن أن تكون إما إيجابية أو سلبية ، وتدفع / وردت عندما يتم الاحتفاظ موقف مفتوح بين عشية وضحاها. فهي مختلفة للمراكز الطويلة والقصيرة ، وتختلف عبر أدوات مختلفة.",
	"cal_swap_MT4_MT5": "MT4/MT5",
	"cal_swap_ACT": "ACT",
	"cal_swap_Field_req": "الحقل مطلوب",
	"cal_swap_accBaseCurr": "عملة الحساب الأساسية",
	"cal_swap_Symbol": "رمز",
	"cal_swap_Num_Days": "عدد الأيام",
	"cal_swap_trade_size_lot": "حجم التجارة (بالقرعة)",
	"cal_swap_Swap_Long": ">سب لونغ",
	"cal_swap_Swap_Short": "مبادلة قصيرة",
	"cal_Position_Size": "حجم الموضع",
	"cal_position_txt": "Fxviewâ € ق ™حجم الموقف آلة حاسبة يساعدك على حساب عدد الكثير من موقف يمكنك فتح ، نظرا لمبلغ محدد مسبقا كنت على استعداد للمخاطرة بفقدان. ما عليك سوى تحديد فئة الأصول، والعملة الأساسية للحساب، والرمز، ونوع المركز، والسعر المفتوح، ووقف الخسارة، ورصيد الحساب، ونسبة المخاطر (أي النسبة المئوية لرصيد حسابك الذي ترغب في المخاطرة بفقدانه)، ثم اضغط على \"حساب الآن\".",
	"cal_position_Field_req": "الحقل مطلوب",
	"cal_position_accBaseCurr": "عملة الحساب الأساسية",
	"cal_position_Symbol": "رمز",
	"cal_position_Position_Type": "نوع الموضع",
	"cal_position_BUY": "ابتاع",
	"cal_position_SELL": "باع",
	"cal_position_Open_Price": "سعر مفتوح",
	"cal_position_Account_Balance": "رصيد الحساب",
	"cal_position_Stop_Loss": "وقف الخسارة",
	"cal_position_Risk_Perc": "نسبة المخاطر",
	"cal_position_trade_size_lot": "حجم التجارة في الكثير",
	"cal_position_Now": "حساب الآن",
	"cal_curr_Convertor": "محول العملات",
	"cal_curr_conv_txt": "Fxviewâ € ق ™تحويل العملات يسمح للمستخدمين للتحقق من قيمة عملة واحدة مقابل غيرها على أساس أسعار الصرف الحالية. مع تحويل العملات لدينا، يمكنك تحويل أي عملتين مع بضع نقرات فقط.",
	"cal_curr_conv_From": "العملة من",
	"cal_curr_conv_To": "العملة إلى",
	"cal_curr_conv_Amount": "مبلغ",
	"cal_curr_conv_Field_req": "الحقل مطلوب",
	"cal_curr_conv_Now": "حساب الآن",
	"cal_curr_conv_Converted": "العملة المحولة",
	"cal_leftmenu_commision": "عمولة",
	"cal_leftmenu_margin": "هامش",
	"cal_leftmenu_multiTarget": "متعدد الأهداف",
	"cal_leftmenu_pivotpoints": "النقاط المحورية",
	"cal_leftmenu_profitloss": "الربح والخسارة",
	"cal_leftmenu_fibonacci": "Fibonacci",
	"cal_leftmenu_pipValue": "قيمة النقطة",
	"cal_leftmenu_Swap": "عمولة التبييت",
	"cal_leftmenu_positionSize": "حجم الصفقة",
	"cal_leftmenu_currencyConv": "محول العملات",
	"suppIndex_requestServices": "دعم",
	"suppIndex_OpenRequests": "تذاكر مفتوحة",
	"suppIndex_ClosedRequests": "تذاكر مغلقة",
	"suppReqService_support": "دعم",
	"suppReqService_howassist": "كيف يمكننا مساعدتك؟",
	"suppReqService_emailus": "مراسلتنا عبر البريد الإلكتروني",
	"suppReqService_email": "info@fxview.com",
	"suppReqService_liveChat": "الدردشة المباشرة",
	"suppReqService_avail24": "متوفر على مدار الساعة طوال اليوم",
	"suppReqService_requestcallback": "طلب إعادة الاتصال",
	"suppReqService_office": "المكتب: +442031505221",
	suppReqService_support_phn: 'Support: +442031505221',
	"suppReqService_createTicket": "إنشاء تذكرة دعم",
	"suppReqService_helpSupport": "كيف يمكننا المساعدة؟",
	"suppReqService_back": "خلف",
	"suppReqService_AddPaymentMethod": "إضافة طريقة الدفع",
	"ZULU": "Zulu",
	"MQL5": "MQL5",
	"depositBonus": "مكافأة الإيداع",
	"referfriend": "الرجوع إلى صديق",
	"supp_Wallet": "محفظة",
	"contactReq": "وقت الاتصال مطلوب.",
	"support_ticketNumber": "رقم التذكرة",
	"support_reason": "سبب",
	"support_created": "تاريخ",
	"support_action": "فعل",
	"suppview_backToTicket": "الصفحة الرئيسية للدعم",
	"suppview_thankyou": "شكرا لك على التحقق من هويتك، ومرحبا بكم في Fxview! يمكنك الآن فتح حساب تداول مباشر وبدء التداول.",
	"suppview_createliveAcc": "إنشاء حساب حقيقي",
	"suppview_whilevalidate1": "أثناء التحقق من صحة مستند إثبات العنوان، لاحظنا أن العنوان ورقم الهوية الذي تم إدخاله أثناء التسجيل لا يتطابق مع المستند الذي تم تحميله أثناء التحقق.",
	"suppview_whilevalidate2": "أثناء التحقق من صحة مستند إثبات العنوان، لاحظنا أن العنوان الذي تم إدخاله أثناء التسجيل لا يتطابق مع المستند الذي تم تحميله أثناء التحقق.",
	"suppview_whilevalidate3": "أثناء التحقق من صحة مستند إثبات العنوان، لاحظنا أن رقم الهوية الذي تم إدخاله أثناء التسجيل لا يتطابق مع المستند الذي تم تحميله أثناء التحقق.",
	"suppview_originalAdress": "العنوان الأصلي",
	"suppview_stepMsz18": "لا أريد تغيير أي شيء",
	"suppview_preQues": "السؤال السابق",
	"suppview_nextQues": "السؤال التالي",
	"suppview_stepMsz21": "حل التعارض",
	"suppview_idNumEnt": "رقم معرف تم إدخاله",
	"suppview_percentComplete": "النسبة المئوية للاكتمال",
	"suppview_nationalityEntered": "تم إدخال الجنسية",
	"suppview_fillone": "الرجاء تعبئة حقل واحد على الأقل",
	"otpVerif_otpVerification": "التحقق من OTP",
	"otpVerif_otpVerificationText1": "تم إرسال دبوس مرة واحدة إلى بريدك الإلكتروني.",
	"otpVerif_resendOtpTicket": "ألم تتلق رسالة بريد إلكتروني في صندوق البريد الوارد أو مجلد الرسائل غير المرغوب فيها؟ ارسال",
	"otpVerif_back": "خلف",
	"otpVerif_backToTicket": "الصفحة الرئيسية للدعم",
	"profileReq_getHelpWith": "الحصول على مساعدة",
	"profileReq_Queries": "الاستعلامات ذات الصلة",
	"profileReq_relatedTopics": "موضوعات ذات صلة",
	"profileReq_inversterPass": "في حال واجهت أي مشاكل في إعداد كلمة مرور المستثمر من منصة MT4/MT5، يرجى المتابعة في إنشاء طلب الدعم",
	"profileReq_notSatisfied": "لست راضيا",
	"profileReq_lodgeComplaint": "تقديم شكوى",
	"profileReq_helpUsWithYour": "ساعدنا في",
	"profileReq_askOtherQuestions": "اسألنا أي سؤال آخر",
	"profileReq_AddBankDetails": "إضافة تفاصيل البنك",
	"profileReq_AddSkrillDetails": "إضافة تفاصيل معرف سكريل",
	"profileReq_AddNetellerDetails": "إضافة تفاصيل معرف نيتيلر",
	"profileReq_AddCreditCardDetails": "إضافة تفاصيل بطاقة الائتمان",
	"profileReq_inn": "في",
	"profileReq_emailHeading": "الرجاء إدخال معرف البريد الإلكتروني الجديد أدناه",
	"profileReq_exsistsEmailAddress": "عنوان البريد الإلكتروني الموجود",
	"profileReq_newEmail": "أدخل عنوان بريدك الإلكتروني الجديد",
	"profileReq_EmailfieldValid": "الرجاء إدخال عنوان بريد إلكتروني صالح",
	"profileReq_EmailfieldReq": "حقل البريد الإلكتروني مطلوب",
	"profileReq_changeEmailAddress": "تغيير عنوان البريد الإلكتروني",
	"profileReq_mobileHeading": "الرجاء إدخال رقم هاتفك النقال الجديد أدناه",
	"profileReq_existingMobileNumber": "رقم الجوال الحالي",
	"profileReq_InvalidNumber": "رقم غير صالح",
	"profileReq_changeMobileNumber": "تغيير رقم الجوال",
	"profileReq_postCodeRequired": "رمز النشر مطلوب",
	"profileReq_residenceCountryRequired": "بلد الإقامة مطلوب",
	"profileReq_uploadRecentAddressProof": "تحميل دليل العنوان الأخير ",
	"profileReq_docReq": "المستند مطلوب",
	"profileReq_changeAddress": "تغيير العنوان",
	"profileReq_bankName": "اسم البنك:",
	"profileReq_AccountName": "اسم الحساب",
	"profileReq_bankNameRequired": "اسم البنك مطلوب",
	"profileReq_accountHolderRequired": "اسم صاحب الحساب مطلوب",
	"profileReq_AccNumber": "رقم الحساب:",
	"profileReq_accountNumberRequired": "رقم الحساب مطلوب",
	"profileReq_country": "بلد",
	"profileReq_countryFieldRequired": "الحقل القطري مطلوب",
	"profileReq_IBAN": "ايبان",
	"profileReq_ibanRequired": "iban مطلوب",
	"profileReq_MyBankNotIBAN": "البنك الذي تتعامل معه لا يصدر ™رقم الحساب المصرفي الدولي",
	"profileReq_SwiftCode": "رمز سويفت/BIC/الفرز",
	"profileReq_swiftCodeRequired": "مطلوب رمز سريع",
	"profileReq_bankAdd": "عنوان البنك:",
	"profileReq_bankAddressRequired": "عنوان البنك مطلوب",
	"profileReq_UpBankStatement": "تحميل كشف حساب بنكي",
	"profileReq_fileallow": "يسمح فقط jpg، jpeg، بابوا غينيا الجديدة، pdf، docx، وثيقة، xls، xlsx الملفات!",
	"profileReq_addNewBank": "إضافة حساب بنكي جديد",
	"profileReq_last4Digit": "آخر 4 أرقام مطلوب ويحتوي على حرف رقمي فقط",
	"profileReq_first4Digit": "الأرقام 4 الأولى مطلوب ويحتوي على حرف رقمي فقط",
	"profileReq_frontBack": "نحن نطلب ما يلي للتحقق من البطاقة -",
	"profileReq_frontPhotoCredit": "نسخة ملونة من الجانب الأمامي من البطاقة، تبين: الاسم الكامل وتاريخ انتهاء الصلاحية واسم البنك / الشعار، أول 4 وآخر 4 أرقام من رقم بطاقة الائتمان إخفاء الأرقام 8 الأوسط.",
	"profileReq_uploadSupportingDocument": "تحميل مستند دعم",
	"profileReq_backPhotoCredit": "نسخة ملونة من الجانب الخلفي من البطاقة مع خفي رمز أمان CVV. يجب أن تظهر النسخة الخلفية توقيع صاحب الحساب.",
	"profileReq_submit": "إرسال",
	"profileReq_paymentRequiredNumeric": "حقل معرف الدفع مطلوب وقد يحتوي على أحرف رقمية فقط.",
	"profileReq_netSkrill1": "يرجى تحميل لقطة شاشة من",
	"profileReq_netSkrill2": "ملف التعريف الذي يتصل بالاسم الكامل،",
	"profileReq_netSkrill3": "معرف وعنوان. سنطابق الاسم والعنوان",
	"profileReq_userDetails": "تفاصيل المستخدم",
	"profileReq_ComplaintDetails": "تفاصيل الشكوى",
	"profileReq_employeeWhoOffered": "الموظف الذي عرض الخدمات على العميل:",
	"profileReq_timeDisputed": "تاريخ ووقت الوضع المتنازع عليه (في وقت خادم MetaTrader):",
	"profileReq_TheDisputeTime": "وقت النزاع مطلوب",
	"profileReq_ticNoContested": "رقم التذكرة (الأرقام) لجميع المراكز المتنازع عليها و/أو الأوامر المعلقة:",
	"profileReq_DisputedAmount": "المبلغ المتنازع عليه:",
	"profileReq_reportComplaint": "هل أبلغت شكواك إلى أي هيئة إشرافية؟",
	"profileReq_stateNameAuth": "يرجى ذكر اسم الهيئة الإشرافية",
	"profileReq_TheAuthorityName": "اسم السلطة مطلوب",
	"profileReq_DetailedDescript": "وصف مفصل للشكوى:",
	"profileReq_attachTogetherForm": "يرجى إرفاق مع هذا النموذج أي دليل داعم لادعاءك من شأنها أن تسهل التحقيق fxview من شكواك. قد تتكون الأدلة الداعمة من أي وثائق (لقطات الشاشة والدردشات وسجلات الهاتف وما إلى ذلك) ذات الصلة بالشكوى.",
	"profileReq_Subject": "موضوع",
	"profileReq_yourMsz": "رسالتك",
	"profileReq_ticketHasbeenComplaint": "تم تسجيل شكواك بنجاح",
	"profileReq_ticketHasbeenCreated": "تم إنشاء تذكرتك",
	"profileReq_proMsz19": "الذهاب إلى التذاكر",
	"profileReq_entervalidcard": "الرجاء إدخال رقم بطاقة صالح",
	"profileReq_changeEmail": "يرجى تغيير بريدي الإلكتروني وفقا للتفاصيل التالية <br> البريد الإلكتروني القديم :",
	"profileReq_NEWEmail": "<br> البريد الإلكتروني الجديد :",
	"profileReq_changeMobile": "يرجى تغيير رقم هاتفي وفقا للتفاصيل التالية <br> رقم قديم : ",
	"profileReq_newNumber": "<br> رقم جديد :",
	"profileReq_changebankinfo": "يرجى تغيير معلومات البنك حسب التفاصيل التالية <br> رقم الحساب :",
	"profileReq_holdername": "<br> اسم الحامل :",
	"profileReq_bankname": "<br> اسم البنك : ",
	"profileReq_bankcode": "<br> كود البنك :",
	"profileReq_sortcode": "<br> رمز الفرز :",
	"profileReq_bankAddress": "<br> عنوان البنك :",
	"profileReq_changeadress": "يرجى تغيير عنواني وفقا للتفاصيل التالية <br> العنوان1 : ",
	"profileReq_adresstwo": "<br> العنوان2 :",
	"profileReq_postcode": "<br> رمز البريد :",
	"profileReq_residenceCountry": "<br> بلد الإقامة :",
	"profileReq_nation": "<br> جنسية: ",
	"profileReq_City": "<br> مدينة:",
	"profileReq_pleaseAdd": "الرجاء إضافة",
	"profileReq_paymentmethod": "طريقة الدفع لكل التفاصيل <br>التالية",
	"profileReq_number": "رقم:",
	"profileReq_expiryDate": "<br> تاريخ انتهاء الصلاحية :",
	"profileReq_id": "معرف:",
	"autoscan_AutochartistScanner": "ماسح ضوئي للشاري التلقائي",
	"autoscan_IBintegrateAdvancedTool": "AutoChartist هو برنامج التعرف على نمط الرسم البياني الممتاز الذي يمسح أدوات التداول ويعترف تلقائيا بأجهزة إعداد التجارة استنادا إلى الاختراقات والتتبعات ومستويات الدعم والمقاومة بحيث لا تفوت فرصة مرة أخرى.",
	"autoscan_closeMt4": "سجل الدخول إلى حسابك في fxview MT4.",
	"autoscan_DownloadRunAuto": "تحميل وتشغيل تطبيق الماسح الضوئي AutoChartist.",
	"autoscan_SelectPortfoliosTrading": "حدد fxview MT4 منصة والمضي قدما في التثبيت.",
	"autoscan_RestartMt4Platform": "إعادة تشغيل منصة FXVIEW MT4.",
	"autoscan_autochartistdesc": "يمكن استخدام ماسح الرسوم التلقائية على حساب MT4 المباشر بحد أدنى للإيداع يبلغ 200 دولار.",
	"autoscan_DisclaimerAutoChartist": "تنويه : تعتبر المشاركات في هذه الصفحة اتصالات تسويقية ولا تحتوي على ، ولا ينبغي تفسيرها على أنها تحتوي على مشورة استثمارية أو توصية استثمارية أو عرض أو التماس لأي معاملات في الأدوات المالية. الأداء السابق لا يدل على النتائج المستقبلية. اطلب مشورة مستقلة إذا لزم الأمر.",
	"autochar_autocharist": "مخطط تلقائي ",
	"autochar_CreateLiveAccount": "إنشاء حساب مباشر",
	"autochar_Cancel": "إلغاء الأمر",
	"subVerf_reqVerify": "طلب التحقق",
	"subVerf_dear": "سيد او سيدة",
	"subVerf_your": "الخاص بك",
	"subVerf_accountVerMsz1": "تمت معالجة الطلب بنجاح",
	"subVerf_backSubList": "العودة إلى أدوات susbcription",
	"subtrans_heading": "تفاصيل حركة الاشتراك",
	"subtrans_date": "التاريخ (تم إنشاؤه)",
	"subtrans_payType": "نوع الدفع",
	"subtrans_planprice": "سعر الخطة",
	"subtrans_coupon": "كوبون",
	"subtrans_amount": "مبلغ",
	"subtrans_noData": "لا توجد بيانات",
	"subtrans_backVPSlist": "العودة إلى قائمة VPS",
	"vpsdetail_heading": "تفاصيل VPS",
	"vpsdetail_IPAddress": "عنوان IP",
	"vpsdetail_ServerId": "معرف الخادم",
	"vpsdetail_HostName": "اسم المضيف",
	"vpsdetail_Disk": "قرص",
	"vpsdetail_Cpu": "وحده المعالجه المركزيه",
	"vpsdetail_Memory": "ذاكرة",
	"vpsdetail_State": "حالة",
	"vpsdetail_Created": "تاريخ",
	"vpsdetail_action": "فعل",
	"toolbox_tradeToolbox": "Traderâ € ™ ™ق أداة مربع",
	"toolbox_moreAboutTradeToolbox": "العثور على المزيد حول صندوق أدوات Traderâ € ™™ ق",
	"toolbox_tradeToolMsz1": "إثراء التداول الخاص بك مع fxview Traderâ € ™ ™ق أداة مربع - مجموعة من المؤشرات القوية والتطبيقات التي تضيف الراحة لرحلة التداول الخاصة بك.",
	"toolbox_WhatYouGet": "ما تحصل عليه",
	"toolbox_TraderToolboxApp": "Traderâ € ™ ™ق أداة مربع التطبيق",
	"toolbox_TradeTerminal": "محطة التجارة",
	"toolbox_MiniTerminal": "محطة صغيرة",
	"toolbox_AlarmsManager": "مدير أجهزة الإنذار",
	"toolbox_ExcelRTD": "إكسل RTD",
	"toolbox_Connect": "عشق",
	"toolbox_SentimentTrader": "تاجر المشاعر",
	"toolbox_SessionMap": "خريطة الجلسة",
	"toolbox_MarketManager": "مدير السوق",
	"toolbox_CorrelationMatrix": "مصفوفة الارتباط",
	"toolbox_CorrelationTrader": "تاجر الارتباط",
	"toolbox_TickTrader": "تاجر التجزئة",
	"toolbox_StealthOrder": "ترتيب الشبح",
	"toolbox_IndicatorPackage": "حزمة المؤشرات",
	"toolbox_Minichart": "مخطط مصغر",
	"toolbox_PivotPoints": "النقاط المحورية",
	"toolbox_HighsLows": "الارتفاعات والانخفاضات",
	"toolbox_Renkobars": "أشرطة رينكو",
	"toolbox_ChartGroup": "مجموعة المخططات",
	"toolbox_SymbolInfo": "معلومات الرمز",
	"toolbox_Gravity": "جاذبية",
	"toolbox_Chart_in_Chart": "مخطط في التخطيط",
	"toolbox_PeriodConverter": "محول الفترة",
	"toolbox_Magnifier": "مكبّر",
	"toolbox_OrderHistory": "تاريخ الطلب",
	"toolbox_FreehandDrawing": "الرسم اليدوي",
	"toolbox_BarChanger": "مغير شريط",
	"toolbox_KeltnerChannel": "قناة كيلتنر",
	"toolbox_DonchianChannel": "قناة دونشيان",
	"toolbox_CandleCountdown": "العد التنازلي شمعة",
	"toolbox_LinearRegression": "الانحدار الخطي",
	"toolbox_howtoinstall": "كيفية تثبيت مربع أداة التاجر",
	"toolbox_loginFxViewmt45": "تسجيل الدخول إلى حسابك fxview MT4/5",
	"toolbox_ToolboxApplication": "تحميل وتشغيل MT4/5 Traderâ € ™ ™ق تطبيق مربع أداة",
	"toolbox_FxviewMT45installation": "حدد fxview MT4/5 منصة والمضي قدما في التثبيت",
	"toolbox_allowDdlImports": "انقر على الأدوات> الخيارات> مستشار خبير> ثم انقر فوق موافق للسماح باستيراد DDL",
	"toolbox_RestartFxviewMT45": "إعادة تشغيل fxview MT4/5 منصة",
	"toolbox_tradeToolboxliveMinDeposit": "يمكن استخدام تطبيق صندوق أدوات التاجر على حساب MT4/5 المباشر بحد أدنى للإيداع يبلغ 500 دولار.",
	"toolbox_DisclaimerAutoChartist": "تنويه : تعتبر المشاركات في هذه الصفحة اتصالات تسويقية ولا تحتوي على ، ولا ينبغي تفسيرها على أنها تحتوي على مشورة استثمارية أو توصية استثمارية أو عرض أو التماس لأي معاملات في الأدوات المالية. الأداء السابق لا يدل على النتائج المستقبلية. اطلب مشورة مستقلة إذا لزم الأمر.",
	"subscription_Subscriptionheading": "الاشتراكات",
	"subscription_SubMsz": "خذ خطتك المطلوبة للوصول إلى المحتوى الخاص بنا بسهولة ، نود أن نقدم عرض ترخيص خاص لمستخدمينا.",
	"subscription_mnth": "/ شهر",
	"subscription_freeMin": "مجانا - الحد الأدنى",
	"subscription_deposit": "إيداعات",
	"subscription_Features": "ملامح",
	"subscription_window": "نافذة",
	"subscription_Memory": "ذاكرة",
	"subscription_ssdDisk": "قرص SSD",
	"subscription_create": "إنشاء",
	"subticket_getSubPlan": "احصل على اشتراك لهذه الخطة",
	"subticket_applyCouponCode": "رمز القسيمة المطبق :",
	"subticket_TotalAmount": "المبلغ الإجمالي",
	"subticket_havePromoCode": "هل لديك رمز ترويجي؟",
	"subticket_deducedMonthlySubscription": "يرجى تحديد معرف التداول من حيث تريد أن يتم استنتاج التكلفة للاشتراك الشهري في حالة عدم استيفاء الحد الأدنى من الشروط ™ل VPS مجانا.",
	"subticket_demo": "عرض",
	"subticket_live": "حقيقي",
	"subticket_noteUnsubTool": "ملاحظة: سيتم خصم الدفع فقط بمجرد النقر على الاشتراك",
	"subticket_clickToAgree": "انقر هنا للاتفاق",
	"subticket_vpsTC": "VPS T&amp.C.",
	"subticket_linkToSub": "يرجى النقر على هذا الرابط للاشتراك.",
	"subticket_subsucce": "تم الاشتراك بنجاح. لمعرفة المزيد من التفاصيل، انقر على الزر أدناه",
	"subticket_AutoChartPage": "الانتقال إلى صفحة المخطط التلقائي",
	"subticket_controlsignalPage": "الانتقال إلى صفحة إشارة التحكم",
	"subticket_researchReportpage": "انتقل إلى صفحة تقارير البحث",
	"subticket_currentNewsPage": "انتقل إلى صفحة الأخبار الحالية",
	"subticket_economicCalPage": "انتقل إلى صفحة التقويم الاقتصادي",
	"subticket_vpsPage": "انتقل إلى صفحة VPS",
	"subticket_selectPromoCode": "حدد الرمز الترويجي ",
	"subticket_EnterCouponCode": "أدخل رمز القسيمة",
	"subticket_Apply": "طبق",
	"subticket_For": "من أجل",
	"subticket_noPromoCode": "لم يكن لديك أي Promocode حتى الآن!",
	"subticket_vpsSubPlan": "اشتراك VPS الخطة",
	"subticket_createVPS": "يرجى إضافة أموال لإنشاء VPS",
	"subticket_goDepositPage": "انتقل إلى صفحة الإيداع",
	"noTradingCreateNewOne": "لا يوجد حساب تداول بعد، إنشاء حساب جديد",
	"faMszOtp1": "أو استخدام يمكن أيضا استخدام 2fa OTP ولكن يجب عليك تمكين أولا عن طريق النقر على الرابط أدناه",
	"RESEND_EMAIL": "إعادة إرسال البريد الإلكتروني",
	"TECH_ERROR": "نحن نواجه بعض القضايا ، يرجى محاولة بعد بعض الوقت",
	"VALIDATION_ERROR": "خطأ التحقق من الصحة",
	"INVALID_TRADING_ACC": "خطأ حساب تداول غير صالح",
	"INVALID_WITHDRAWAL_TRANSACTION": "حركة سحب غير صالحة",
	"INVALID_OTP": "OTP غير صالح",
	"FILE_UPLOAD": "يسمح فقط jpg، jpeg، بابوا غينيا الجديدة، ملفات pdf!",
	"OTP_EXPIRED": "انتهت مدة صلاحية OTP",
	"OTP_IP_MISMATCH": "OTP غير متطابق",
	"LOW_BALANCE_THEN_AMOUNT": "المبلغ الذي أدخلته أعلى من الهامش الحر المتاح.",
	"TICKET_EXIST": "تذكرة موجودة بالفعل",
	"EMAIL_EXIST": "البريد الإلكتروني موجود بالفعل",
	"MOBILE_EXIST": "رقم الهاتف المحمول موجود بالفعل",
	"LOW_BONUS_THEN_AMOUNT": "المبلغ الذي كنت قد ملأت منخفضة ثم مكافأة الخاص بك",
	"INVALID_ACCOUNT_TRANSACTION": "حركة حساب غير صالحة",
	"INVALID_TICKET_TRANSACTION": "حركة تذاكر غير صالحة",
	"DEPOSIT_LIMIT": "حد الإيداع",
	"AMOUNT_GREATER_THEN_ALLOWED": "المبلغ الذي أدخلته أعلى ثم المسموح به.",
	"fund_msz": "الإيداع بنجاح",
	"suceessMsz1": "تمكين 2FA بنجاح",
	"suceessMsz2": "تم تعطيل 2FA",
	"suceessMsz3": "تم إرسال رابط لتغيير كلمة المرور على معرف البريد الإلكتروني المسجل",
	"suceessMsz4": "تم تغيير كلمة المرور بنجاح",
	"suceessMsz5": "OTP إعادة إرسال بنجاح",
	"suceessMsz6": "يتم إرسال OTP على البريد الإلكتروني الخاص بك سجل ورقم الهاتف المحمول",
	"suceessMsz7": "الآن أنت مؤهل لفتح حساب حقيقي",
	"suceessMsz8": "يرجى تحميل المستند في غضون 15 يوما",
	"suceessMsz9": "إضافة اسم بنجاح",
	"suceessMsz10": "تم إرسال رابط معرف البريد الإلكتروني المسجل الخاص بك",
	"suceessMsz11": "خطة إلغاء الاشتراك بنجاح",
	"suceessMsz12": "إعادة تشغيل الخدمة بنجاح",
	"suceessMsz13": "إعادة تشغيل الخدمة بنجاح",
	"suceessMsz14": "إيقاف تشغيل الخدمة بنجاح",
	"suceessMsz15": "تم تغيير كلمة مرور الخدمة بنجاح",
	"suceessMsz16": "تم إرسال رابط إلى عنوان بريدك الإلكتروني المسجل",
	"suceessMsz17": "الإيداع بنجاح",
	"suceessMsz18": "OTP إعادة إرسال بنجاح",
	"suceessMsz19": "إضافة بنك بنجاح",
	"suceessMsz20": "تم إنشاء تذكرة بنجاح ويرجى الانتظار لمدة 2-3 أيام عمل",
	"suceessMsz21": "في هذه اللحظة نحن نسمح 1,00,000,000 فقط. في حال كنت ترغب في إيداع أكثر من هذا يرجى الاتصال بالدعم",
	"suceessMsz22": "لا يسمح لك بإدخال مبلغ أكبر  أو مساوي لحد الإيداع - ، لأنك لم يتم التحقق من الوثائق بعد ولا يزال المستند قيد التحقق لذلك لا يمكنك إيداع أكثر من 2000 يورو. ",
	"suceessMsz23": "مبلغ غير صالح",
	"suceessMsz24": "لم يتم التحقق من حسابك",
	"suceessMsz25": "يجب أن يختلف معرف الحساب عن معرف حساب آخر حددته : ",
	"suceessMsz26": "حدد خيارين على الأقل ",
	"suceessMsz27": "كلمة المرور الجديدة ليست مثل تأكيد كلمة المرور الجديدة",
	"suceessMsz28": "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل، وأن تتضمن رقما ورقما كبيرا واحد على الأقل وحرفا خاصا واحد (!@#$٪^&/)",
	"suceessMsz29": "",
	"errorMsz1": "معذرة! تم إنتهاء صلاحية هذا الارتباط. انقر فوق <router-link :إلى='/نسيت كلمة المرور'>هنا</router-link> لإعادة تعيين مرة أخرى!",
}


// WEBPACK FOOTER //
// ./src/plugins/lang/languages/ar.js